import MapLoader from 'google-maps';
import turf from 'turf'
import pointToLineDistance from '@turf/point-to-line-distance'
import simplify from 'simplify-js'
import Tolls from '../../../services/toll'
import Route from '../../../services/route'
import {cents} from '../../../filters/number'
import RoutingMixin from './routing-mixin'
import C from '../../common/constantes';

export default {
  mixins: [RoutingMixin],
  data(){
    return {
      axesOp: C.Axes
    }
  },
  mounted(){
    
  }

}


var all2 = [
  {
      "i": "6gy6fdne77b3",
      "h": "S",
      "s": "Sorocaba , SP - Rod. Sen. José Ermirio de Moraes (SP 75) - Km 12",
      "r": 50,
      "p": 6.2,
      "lat": -23.41141495960481,
      "lng": -47.341834511607885,
      "corrected": true
  },
  {
      "i": "6gy6gdgwrrpt",
      "h": "L",
      "s": "Itú , SP - Rod. Pres. Castelo Branco (SP 280) - Km 74",
      "r": 50,
      "p": 11,
      "lat": -23.406328780124117,
      "lng": -47.301602717489004,
      "corrected": true
  },
  {
      "i": "6gyecd0t0ubp",
      "h": "A",
      "s": "Itupeva, SP - Rod. Dom Gabriel Paulino Bueno Couto (SP 300) - Km 76",
      "r": 100,
      "p": 7,
      "lat": -23.235377011038008,
      "lng": -47.04267231747508,
      "corrected": true
  },
  {
      "i": "6gyvxt4pgv00",
      "h": "A",
      "s": "Vargem, SP - Rod. Fernão Dias (BR 381) - Km 7",
      "r": 1000,
      "p": 2.1,
      "lat": -22.910656582249107,
      "lng": -46.42533240839839,
      "corrected": true
  },
  {
      "i": "6gvuununc480",
      "h": "A",
      "s": "Conchas, SP - Rod. Mal. Rondon (SP 300) - Km 192",
      "r": 200,
      "p": 6.5,
      "lat": -23.03302102579438,
      "lng": -47.982712145894766,
      "corrected": true
  },
  {
      "i": "6gyhv7ud5vxt",
      "h": "A",
      "s": "Rafard, SP - Rod. Bento Antônio de Moraes (SP 101) - Km 55",
      "r": 300,
      "p": 4.8,
      "lat": -23.05083578341415,
      "lng": -47.57543010637164,
      "corrected": true
  },
  {
      "i": "6gyjdm7e7zrc",
      "h": "A",
      "s": "Rio das Pedras, SP - Rod. Cornelio Pires (SP 127) - Km 58",
      "r": 100,
      "p": 9.4,
      "lat": -22.910351122908658,
      "lng": -47.70872248336673,
      "corrected": true
  },
  {
      "i": "6gyjvzq9ukzf",
      "h": "A",
      "s": "Rio das Pedras, SP - Rod. do Açúcar (SP 308) - Km 147",
      "r": 300,
      "p": 6,
      "lat": -22.855716922224104,
      "lng": -47.551421988755465,
      "corrected": true
  },
  {
      "i": "6gym62vt8hbm",
      "h": "A",
      "s": "Monte Mor, SP - Rod. Jorn. Francisco Aguirra Proença (SP 101) - Km 29",
      "r": 300,
      "p": 6.7,
      "lat": -22.97891024332611,
      "lng": -47.35442781820893,
      "corrected": true
  },
  {
      "i": "6gypnevu8ezz",
      "h": "A",
      "s": "Iracemápolis, SP - Rod. Dep. Laércio Corte (SP 147) - Km 127",
      "r": 100,
      "p": 5.6,
      "lat": -22.65437473017591,
      "lng": -47.51881504431367,
      "corrected": true
  },
  {
      "i": "6gysufutjh2k",
      "h": "A",
      "s": "Louveira, SP - Rod. Romildo Prado (SP 063) - Km 10",
      "r": 200,
      "p": 1.8,
      "lat": -23.05528341698146,
      "lng": -46.894250605255365,
      "corrected": true
  },
  {
      "i": "6gyswngnvmr7",
      "h": "A",
      "s": "Jundiaí, SP - Rod. Eng. Constâncio Cintra (SP-360) - Km 77",
      "r": 100,
      "p": 3.4,
      "lat": -23.077001982526102,
      "lng": -46.84134537354112,
      "corrected": true
  },
  {
      "i": "6gzhj0u3bkp9",
      "h": "A",
      "s": "Igaratá, SP - Rod. Dom Pedro I (SP 065) - Km 26",
      "r": 200,
      "p": 8.9,
      "lat": -23.198517216372636,
      "lng": -46.181280221790075,
      "corrected": true
  },
  {
      "i": "6ung1rsubqum",
      "h": "A",
      "s": "Águas da Prata, SP - Rod. Dr. Gov. Adhemar Pereira de Barros (SP 342) - Km 240",
      "r": 100,
      "p": 4.1,
      "lat": -21.930633298476614,
      "lng": -46.69628446921706,
      "corrected": true
  },
  {
      "i": "6gy40b35rcbj",
      "h": "A",
      "s": "Sarapuí, SP - Rod. Raposo Tavares (SP 270) - Km 135",
      "r": 100,
      "p": 7.8,
      "lat": -23.552781651800345,
      "lng": -47.77784300968051,
      "corrected": true
  },
  {
      "i": "6gy4m8j3rx2h",
      "h": "A",
      "s": "Araçoiaba, SP - Rod. Raposo Tavares (SP 270) - Km 111",
      "r": 50,
      "p": 3.7,
      "lat": -23.51038958230081,
      "lng": -47.56331054493785,
      "corrected": true
  },
  {
      "i": "6gy6k0hxedxx",
      "h": "L",
      "s": "Alumínio , SP - Rod. Raposo Tavares (SP 270) - Km 78",
      "r": 50,
      "p": 8.4,
      "lat": -23.509428990774378,
      "lng": -47.278765719383955,
      "corrected": true
  },
  {
      "i": "6gy9c2pdqh00",
      "h": "O",
      "s": "São Roque , SP - Rod. Raposo Tavares (SP 270) - Km 46",
      "r": 50,
      "p": 8.8,
      "lat": -23.598223496717193,
      "lng": -47.043886352330446,
      "corrected": true
  },
  {
      "i": "6gydx67qnrbh",
      "h": "N",
      "s": "São Paulo, SP - Rodo Anel Mário Covas (SP 021) - Km 6",
      "r": 20,
      "p": 2,
      "lat": -23.453358807445202,
      "lng": -46.78609622642398,
      "corrected": true
  },
  {
      "i": "6gydxyww7tb5",
      "h": "N",
      "s": "São Paulo, SP - Rodo Anel Mário Covas (SP 021) - Km 3",
      "r": 20,
      "p": 2,
      "lat": -23.427054001741965,
      "lng": -46.7602196149528,
      "corrected": true
  },
  {
      "i": "6gz4vxp9phxg",
      "h": "A",
      "s": "Guararema, SP - Rod. Ayrton Senna da Silva (SP 070) - Km 57",
      "r": 100,
      "p": 3.4,
      "lat": -23.38425103317745,
      "lng": -46.153913307935,
      "corrected": true
  },
  {
      "i": "6gz5jz65rb0j",
      "h": "A",
      "s": "Guararema, SP - Rod. Pres. Dutra (BR 116) - Km 180",
      "r": 200,
      "p": 3.5,
      "lat": -23.33887169928685,
      "lng": -46.15000767633319,
      "corrected": true
  },
  {
      "i": "6gz72tvqhgb0",
      "h": "L",
      "s": "Jacareí, SP - BR-116 (BR-116) - Km 167",
      "r": 10,
      "p": 6.3,
      "lat": -23.30242361234012,
      "lng": -46.025350000709295,
      "corrected": true
  },
  {
      "i": "6gz72wj01hpf",
      "h": "O",
      "s": "Jacareí, SP - BR-116 (BR-116) - Km 167",
      "r": 10,
      "p": 6.3,
      "lat": -23.302078613461113,
      "lng": -46.02582575753331,
      "corrected": true
  },
  {
      "i": "6gz73p42mnrf",
      "h": "A",
      "s": "Jacareí, SP - Rod. Pres. Dutra (BR 116) - Km 165",
      "r": 200,
      "p": 6.3,
      "lat": -23.296459025851174,
      "lng": -46.00747274234891,
      "corrected": true
  },
  {
      "i": "6gz7s3m58fze",
      "h": "A",
      "s": "São José dos Campos, SP - Rod. Gov. Carvalho Pinto (SP 070) - Km 92",
      "r": 50,
      "p": 3.4,
      "lat": -23.28353547998969,
      "lng": -45.860801842063665,
      "corrected": true
  },
  {
      "i": "6gznysmkzjrw",
      "h": "A",
      "s": "Cambuí, MG - Rod. Fernão Dias (BR-381) - Km 904",
      "r": 300,
      "p": 2.1,
      "lat": -22.69575867752636,
      "lng": -46.11295094713569,
      "corrected": true
  },
  {
      "i": "6gzs20eg8085",
      "h": "A",
      "s": "Caçapava, SP - Rod. Gov. Carvalho Pinto (SP 070) - Km 114",
      "r": 100,
      "p": 2.6,
      "lat": -23.155875878111043,
      "lng": -45.697979014366865,
      "corrected": true
  },
  {
      "i": "6gztxc9q60b6",
      "h": "A",
      "s": "Pindamonhangaba, SP - Rod. Pres. Dutra (BR 116) - Km 88",
      "r": 200,
      "p": 14.4,
      "lat": -22.930200279701186,
      "lng": -45.3607458807528,
      "corrected": true
  },
  {
      "i": "6upd8rz9s48j",
      "h": "A",
      "s": "Careaçu, MG - Rod. Fernão Dias (BR-381) - Km 805",
      "r": 200,
      "p": 2.1,
      "lat": -22.017951687209926,
      "lng": -45.681441854685545,
      "corrected": true
  },
  {
      "i": "6upvenswmhb1",
      "h": "A",
      "s": "Carmo da Cachoeira, MG - Rod. Fernão Dias (BR-381) - Km 723",
      "r": 500,
      "p": 2.1,
      "lat": -21.496798243783854,
      "lng": -45.21092874929309,
      "corrected": true
  },
  {
      "i": "6gz7qr07zt01",
      "h": "A",
      "s": "Jambeiro, SP - Rod. dos Tamoios (SP-099) - Km 59",
      "r": 200,
      "p": 3.7,
      "lat": -23.29578871449806,
      "lng": -45.77930426225066,
      "corrected": true
  },
  {
      "i": "6gydx65h8gxz",
      "h": "S",
      "s": "São Paulo, SP - Rodo Anel Mário Covas (SP 021) - Km 7",
      "r": 30,
      "p": 2,
      "lat": -23.456101306345523,
      "lng": -46.78540823981166,
      "corrected": true
  },
  {
      "i": "6gydx7m10680",
      "h": "O",
      "s": "São Paulo, SP - Rodo Anel Mário Covas (SP 021) - Km 6",
      "r": 30,
      "p": 2,
      "lat": -23.448294477176166,
      "lng": -46.78321922197938,
      "corrected": true
  },
  {
      "i": "6gydxvpnmvbp",
      "h": "S",
      "s": "São Paulo, SP - Rodo Anel Mário Covas (SP 021) - Km 3",
      "r": 20,
      "p": 2,
      "lat": -23.43938576171758,
      "lng": -46.758316587656736,
      "corrected": true
  },
  {
      "i": "6gydz09z0nu0",
      "h": "L",
      "s": "São Paulo, SP - Rod. Anhangüera (SP 330) - Km 26",
      "r": 50,
      "p": 8.9,
      "lat": -23.418951970591507,
      "lng": -46.79949251934886,
      "corrected": true
  },
  {
      "i": "6gydz0f57v81",
      "h": "O",
      "s": "São Paulo, SP - Rod. Anhangüera (SP 330) - Km 26",
      "r": 50,
      "p": 8.9,
      "lat": -23.418343397125895,
      "lng": -46.799059342592955,
      "corrected": true
  },
  {
      "i": "6gyentz8ddxc",
      "h": "S",
      "s": "Caieiras, SP - Rod. dos Bandeirantes (SP 348) - Km 36",
      "r": 50,
      "p": 8.9,
      "lat": -23.347094240007312,
      "lng": -46.81328343227506,
      "corrected": true
  },
  {
      "i": "6gyeqd0qkh2m",
      "h": "N",
      "s": "Franco da Rocha, SP - Rod. dos Bandeirantes (SP 348) - Km 39",
      "r": 50,
      "p": 8.9,
      "lat": -23.322792414268974,
      "lng": -46.82331891730428,
      "corrected": true
  },
  {
      "i": "6gyfb3nd1ypv",
      "h": "L",
      "s": "São Paulo, SP - Rodo Anel Mário Covas (SP 021) - Km 0",
      "r": 50,
      "p": 2,
      "lat": -23.416819214007056,
      "lng": -46.737560983747244,
      "corrected": true
  },
  {
      "i": "6gygk16bhcu2",
      "h": "A",
      "s": "Mairiporã, SP - Rod. Fernão Dias (BR 381) - Km 65",
      "r": 50,
      "p": 2.1,
      "lat": -23.330405084636176,
      "lng": -46.57772848382592,
      "corrected": true
  },
  {
      "i": "6gyudgzcm2ry",
      "h": "A",
      "s": "Atibaia, SP - Rod. Dom Pedro I (SP 065) - Km 79",
      "r": 150,
      "p": 7,
      "lat": -23.094403198755554,
      "lng": -46.62611486390233,
      "corrected": true
  },
  {
      "i": "6un7yn54mqxc",
      "h": "A",
      "s": "Sta. Cruz das Palmeiras, SP - SP-215 (SP-215) - Km 65",
      "r": 100,
      "p": 5.9,
      "lat": -21.808027048314077,
      "lng": -47.19329612329602,
      "corrected": true
  },
  {
      "i": "6un8hxyggvry",
      "h": "A",
      "s": "Mogi Mirim, SP - SP 147 - Km 52",
      "r": 100,
      "p": 7.3,
      "lat": -22.456747868925238,
      "lng": -46.90218022093177,
      "corrected": true
  },
  {
      "i": "6un9ftjxdr25",
      "h": "A",
      "s": "Mogi Guaçu, SP - Rod. Dep. Mário Beni (SP 340) - Km 192",
      "r": 100,
      "p": 6.9,
      "lat": -22.163545340694256,
      "lng": -46.991703640669584,
      "corrected": true
  },
  {
      "i": "6un9qtpdbm80",
      "h": "A",
      "s": "Espírito Santo do Pinhal, SP - Rod. Dr. Gov. Adhemar Pereira de Barros (SP 342) - Km 191",
      "r": 100,
      "p": 8.6,
      "lat": -22.252309683960956,
      "lng": -46.813433300703764,
      "corrected": true
  },
  {
      "i": "6undvbkrjjrd",
      "h": "A",
      "s": "São João da Boa Vista, SP - SP 344 - Km 219",
      "r": 100,
      "p": 4.4,
      "lat": -22.013966354696745,
      "lng": -46.85067242011428,
      "corrected": true
  },
  {
      "i": "6une33f55xry",
      "h": "A",
      "s": "Casa Branca, SP - Rod. Prof. Boanerges Nogueira de Lima (SP 340) - Km 221",
      "r": 200,
      "p": 6.2,
      "lat": -21.918597677762016,
      "lng": -47.05175595358014,
      "corrected": true
  },
  {
      "i": "6unenh7j9egw",
      "h": "N",
      "s": "São João da Boa Vista, SP - Rod. Dom Tomás Vaquero (SP 344) - Km 230",
      "r": 100,
      "p": 4.8,
      "lat": -21.948300800387443,
      "lng": -46.84152474626899,
      "corrected": true
  },
  {
      "i": "6ur738zx70b4",
      "h": "A",
      "s": "Piumhi, MG - MG 050 - Km 270",
      "r": 1000,
      "p": 5.1,
      "lat": -20.517079516709682,
      "lng": -45.978392232209444,
      "corrected": true
  },
  {
      "i": "6ure6q1c9t2r",
      "h": "A",
      "s": "Córrego Fundo, MG - MG 050 - Km 219",
      "r": 1000,
      "p": 5.1,
      "lat": -20.48924581903651,
      "lng": -45.60175912454724,
      "corrected": true
  },
  {
      "i": "75cmfg5zneb5",
      "h": "L",
      "s": "Niterói, RJ - Ponte Pres. Costa e Silva (BR 101) - Km 322",
      "r": 100,
      "p": 4.1,
      "lat": -22.877872401284193,
      "lng": -43.11579896137118,
      "corrected": true
  },
  {
      "i": "75cpr00x5mxu",
      "h": "A",
      "s": "Duque de Caxias, RJ - Rod. Washington Luiz (BR 040) - Km 104",
      "r": 70,
      "p": 12.4,
      "lat": -22.630524827029106,
      "lng": -43.28530551865697,
      "corrected": true
  },
  {
      "i": "75cqqvcs1fxf",
      "h": "O",
      "s": "São Gonçalo, RJ - BR 101 - Km 299",
      "r": 100,
      "p": 5,
      "lat": -22.775201181891227,
      "lng": -42.94532446190715,
      "corrected": true
  },
  {
      "i": "75cr1jpmqrxv",
      "h": "A",
      "s": "Eng. Pierre Berman, RJ - Rod. Pres. Dutra (BR 116) - Km 133",
      "r": 100,
      "p": 17.1,
      "lat": -22.647266610516766,
      "lng": -43.187958765774965,
      "corrected": true
  },
  {
      "i": "75cr5e3d93re",
      "h": "A",
      "s": "Santa Guilhermina, RJ - Rod. Pres Dutra (BR 116) - Km 122",
      "r": 100,
      "p": 12,
      "lat": -22.65741033923584,
      "lng": -43.086258452385664,
      "corrected": true
  },
  {
      "i": "75crkgbfbqg3",
      "h": "S",
      "s": "Santo Aleixo, RJ - Rod. Pres. Dutra (BR 116) - Km 114",
      "r": 10,
      "p": 8.5,
      "lat": -22.61066923600668,
      "lng": -43.03237086161971,
      "corrected": true
  },
  {
      "i": "75crkgc68gf9",
      "h": "N",
      "s": "Santo Aleixo, RJ - Rod. Pres. Dutra (BR 116) - Km 114",
      "r": 10,
      "p": 12,
      "lat": -22.610858856190994,
      "lng": -43.0317566357553,
      "corrected": true
  },
  {
      "i": "75cwcb9xpjpe",
      "h": "A",
      "s": "Itaboraí, RJ - Rod. Tanguá (RJ 116) - Km 1",
      "r": 100,
      "p": 5.6,
      "lat": -22.715638986431927,
      "lng": -42.8113722614944,
      "corrected": true
  },
  {
      "i": "7h11svhpy7zs",
      "h": "A",
      "s": "Paraíba do Sul, RJ - BR 393 - Km 195",
      "r": 300,
      "p": 6.9,
      "lat": -22.207561654196237,
      "lng": -43.37920596823096,
      "corrected": true
  },
  {
      "i": "7h134z2f9r2p",
      "h": "A",
      "s": "Petrópolis, RJ - Rod. Washington Luiz (BR 040) - Km 45",
      "r": 60,
      "p": 12.4,
      "lat": -22.283865062857075,
      "lng": -43.120307084172964,
      "corrected": true
  },
  {
      "i": "7h15q244mz02",
      "h": "A",
      "s": "Simão Pereira, MG - BR 040 - Km 816",
      "r": 100,
      "p": 12.4,
      "lat": -21.928309458063758,
      "lng": -43.3162615634501,
      "corrected": true
  },
  {
      "i": "7h1e0dqbfwbk",
      "h": "A",
      "s": "Sapucaia, RJ - BR 393 - Km 125",
      "r": 300,
      "p": 6.9,
      "lat": -21.960169789369896,
      "lng": -42.85925505682826,
      "corrected": true
  },
  {
      "i": "7h208c00ekrg",
      "h": "A",
      "s": "Sto. Antônio do Amparo, MG - Rod. Fernão Dias (BR 381) - Km 648",
      "r": 500,
      "p": 2.1,
      "lat": -21.000332116326007,
      "lng": -44.96680514886975,
      "corrected": true
  },
  {
      "i": "6gvfkrrnm08p",
      "h": "S",
      "s": "Itapetininga, SP - Rod. Antônio Romano Schincariol (SP 127) - Km 133",
      "r": 200,
      "p": 10.2,
      "lat": -23.470479603852922,
      "lng": -47.967579793184996,
      "corrected": true
  },
  {
      "i": "6gvftjeykpb2",
      "h": "N",
      "s": "Tatuí, SP - Rod. Antônio Romano Schincariol (SP 127) - Km 128",
      "r": 200,
      "p": 10.2,
      "lat": -23.43479070709944,
      "lng": -47.93826291337609,
      "corrected": true
  },
  {
      "i": "6gvgcb31xfrd",
      "h": "A",
      "s": "Quadra, SP - Rod. Pres. Castelo Branco (SP 280) - Km 158",
      "r": 200,
      "p": 12.5,
      "lat": -23.245880502932163,
      "lng": -48.085774686187506,
      "corrected": true
  },
  {
      "i": "6gy57gg5b4hw",
      "h": "A",
      "s": "Boituva, SP - Rod. Pres. Castelo Branco (SP 280) - Km 111",
      "r": 50,
      "p": 9.1,
      "lat": -23.31364198010932,
      "lng": -47.64353608712554,
      "corrected": true
  },
  {
      "i": "6gy5k514bhrg",
      "h": "A",
      "s": "Boituva, SP - Rod. Pres. Castelo Branco (SP-280) - Km 110",
      "r": 10,
      "p": 9.1,
      "lat": -23.317960128127538,
      "lng": -47.6353201456368,
      "corrected": true
  },
  {
      "i": "6gy5k51p3b8r",
      "h": "A",
      "s": "Boituva, SP - Rod. Pres. Castelo Branco (SP-280) - Km 110",
      "r": 10,
      "p": 9.1,
      "lat": -23.317260055437824,
      "lng": -47.63522693887353,
      "corrected": true
  },
  {
      "i": "6gy5vetcnsb2",
      "h": "A",
      "s": "Porto Feliz, SP - Rod. Dom Gabriel Paulino Bueno Couto (SP 300) - Km 136",
      "r": 100,
      "p": 7.2,
      "lat": -23.227568138382026,
      "lng": -47.562662456184626,
      "corrected": true
  },
  {
      "i": "6gyk6k2yxdpc",
      "h": "A",
      "s": "Salto, SP - Rod. do Açúcar (SP 308) - Km 109",
      "r": 200,
      "p": 3.3,
      "lat": -23.134642831569845,
      "lng": -47.360746432095766,
      "corrected": true
  },
  {
      "i": "6gykycqzkdu3",
      "h": "A",
      "s": "Indaiatuba, SP - Rod. Eng. Ermênio de Oliveira Penteado (SP 075) - Km 60",
      "r": 100,
      "p": 12.8,
      "lat": -23.063135912704254,
      "lng": -47.15480709448457,
      "corrected": true
  },
  {
      "i": "6gykz4ufjzk5",
      "h": "A",
      "s": "Indaiatuba, SP - Rod. Eng. Ermênio de Oliveira Penteado (SP-075) - Km 62",
      "r": 20,
      "p": 12.8,
      "lat": -23.05571121305602,
      "lng": -47.14653415605426,
      "corrected": true
  },
  {
      "i": "6gykz4uw8w4m",
      "h": "A",
      "s": "Indaiatuba, SP - Rod. Eng. Ermênio de Oliveira Penteado (SP-075) - Km 62",
      "r": 20,
      "p": 12.8,
      "lat": -23.055106759210197,
      "lng": -47.147040758281946,
      "corrected": true
  },
  {
      "i": "6gyqyvqsr7ps",
      "h": "A",
      "s": "Cosmópolis, SP - Rod. Gen Milton Tavares de Souza (SP 332) - Km 135",
      "r": 200,
      "p": 8,
      "lat": -22.690225179682372,
      "lng": -47.15501328930259,
      "corrected": true
  },
  {
      "i": "6gyqz1pwycgx",
      "h": "N",
      "s": "Paulínia, SP - Rod. Gen Milton Tavares de Souza (SP 332) - Km 132",
      "r": 10,
      "p": 11.1,
      "lat": -22.713009606629257,
      "lng": -47.142709996551275,
      "corrected": true
  },
  {
      "i": "6gyryj74xzr8",
      "h": "A",
      "s": "Engenheiro Coelho, SP - Rod. Gen. Milton Tavares de Souza (SP 332) - Km 159",
      "r": 200,
      "p": 5.4,
      "lat": -22.514571171919826,
      "lng": -47.192810978740454,
      "corrected": true
  },
  {
      "i": "6gysc6qut7re",
      "h": "S",
      "s": "Itupeva, SP - Rod. dos Bandeirantes (SP 348) - Km 77",
      "r": 50,
      "p": 8.8,
      "lat": -23.05799950842299,
      "lng": -47.04472353681922,
      "corrected": true
  },
  {
      "i": "6gysc6rr4xpc",
      "h": "N",
      "s": "Itupeva, SP - Rod. dos Bandeirantes (SP 348) - Km 77",
      "r": 50,
      "p": 8.8,
      "lat": -23.05758142237664,
      "lng": -47.0442739315331,
      "corrected": true
  },
  {
      "i": "6gyscd9s3qry",
      "h": "A",
      "s": "Vinhedo, SP - Miguel Melhado Campos (SP-324) - Km 81",
      "r": 50,
      "p": 5.5,
      "lat": -23.056688628936598,
      "lng": -47.04125074669719,
      "corrected": true
  },
  {
      "i": "6gyt1fwu4p7c",
      "h": "N",
      "s": "Valinhos, SP - Rod. Anhangüera (SP 330) - Km 82",
      "r": 50,
      "p": 8.8,
      "lat": -23.012825800819083,
      "lng": -47.0230764336884,
      "corrected": true
  },
  {
      "i": "6gyt413cnbzg",
      "h": "S",
      "s": "Valinhos, SP - Rod. Anhangüera (SP 330) - Km 82",
      "r": 50,
      "p": 8.8,
      "lat": -23.02021832487281,
      "lng": -47.01867224648595,
      "corrected": true
  },
  {
      "i": "6gytmtmsr00h",
      "h": "A",
      "s": "Itatiba, SP - Rod. Dom Pedro I (SP 065) - Km 110",
      "r": 100,
      "p": 9.5,
      "lat": -22.9539031058327,
      "lng": -46.85977382585406,
      "corrected": true
  },
  {
      "i": "6gyw3yxkgg86",
      "h": "A",
      "s": "Campinas, SP - Rod. Dr. Gov. Adhemar Pereira de Barros (SP 340) - Km 123",
      "r": 100,
      "p": 11.6,
      "lat": -22.771081981302935,
      "lng": -47.02198812738061,
      "corrected": true
  },
  {
      "i": "6ujsjzcjrbpu",
      "h": "A",
      "s": "Araraquara , SP - Rod. Washington Luiz (SP 310) - Km 282",
      "r": 100,
      "p": 15.7,
      "lat": -21.75317928473464,
      "lng": -48.261619973927736,
      "corrected": true
  },
  {
      "i": "6ujswpe78f6h",
      "h": "A",
      "s": "Araraquara, SP - ARA 080",
      "r": 50,
      "p": 1.5,
      "lat": -21.667155802877936,
      "lng": -48.24747635051608,
      "corrected": true
  },
  {
      "i": "6ujtk5t4p9b7",
      "h": "A",
      "s": "Dobrada, SP - Rod. Brg. Faria Lima (SP 326) - Km 307",
      "r": 50,
      "p": 8.2,
      "lat": -21.557564076891673,
      "lng": -48.33270588889718,
      "corrected": true
  },
  {
      "i": "6ujvkbvqr723",
      "h": "A",
      "s": "Guatapará, SP - Rod. Antônio Machado Sant'ana (SP 255) - Km 45",
      "r": 300,
      "p": 14,
      "lat": -21.5719230290017,
      "lng": -47.948759738355875,
      "corrected": true
  },
  {
      "i": "6um6r98xbmp9",
      "h": "A",
      "s": "COLINA, SP - Rod. Brg. Faria Lima (SP 326) - Km 407",
      "r": 100,
      "p": 8.5,
      "lat": -20.68863871907686,
      "lng": -48.536860551685095,
      "corrected": true
  },
  {
      "i": "6un0xx0vsb02",
      "h": "A",
      "s": "Rio Claro, SP - Rod. Wilson Finardi (SP 191) - Km 59",
      "r": 150,
      "p": 3.2,
      "lat": -22.37301560293005,
      "lng": -47.4817375279963,
      "corrected": true
  },
  {
      "i": "6un2hccz2erv",
      "h": "A",
      "s": "Engenheiro Coelho, SP - Rod. Eng. João Tosello (SP 147) - Km 91",
      "r": 100,
      "p": 5.6,
      "lat": -22.489086578263503,
      "lng": -47.249772381037474,
      "corrected": true
  },
  {
      "i": "6un2v846mzxg",
      "h": "A",
      "s": "Araras, SP - Rod. Wilson Finardi (SP 191) - Km 27",
      "r": 150,
      "p": 6,
      "lat": -22.36825850783726,
      "lng": -47.21588300541043,
      "corrected": true
  },
  {
      "i": "6un33te9cszb",
      "h": "A",
      "s": "Leme, SP - Rod. Anhangüera (SP 330) - Km 181",
      "r": 150,
      "p": 7.4,
      "lat": -22.249632039246144,
      "lng": -47.3900374956429,
      "corrected": true
  },
  {
      "i": "6urx7zyuk820",
      "h": "A",
      "s": "Luz, MG - BR-262 (BR-262) - Km 512",
      "r": 1000,
      "p": 4.7,
      "lat": -19.77584362872386,
      "lng": -45.5290206335485,
      "corrected": true
  },
  {
      "i": "6ux0d876ucpg",
      "h": "A",
      "s": "Campos Altos, MG - BR-262 (BR-262) - Km 600",
      "r": 1000,
      "p": 5,
      "lat": -19.597762801853033,
      "lng": -46.29170944914222,
      "corrected": true
  },
  {
      "i": "75bytp676021",
      "h": "A",
      "s": "Viúva Graça, RJ - Estr. Rio São Paulo (BR 465)",
      "r": 100,
      "p": 14.4,
      "lat": -22.723271790142444,
      "lng": -43.722396958619356,
      "corrected": true
  },
  {
      "i": "75byv0w7gszu",
      "h": "A",
      "s": "Seropédica, RJ - Rod. Pres. Dutra (BR 116) - Km 207",
      "r": 50,
      "p": 14.4,
      "lat": -22.716275376910655,
      "lng": -43.716836739331484,
      "corrected": true
  },
  {
      "i": "75cjwmzd83zt",
      "h": "A",
      "s": "Rio de Janeiro, RJ - Linha Amarela - Km 6",
      "r": 70,
      "p": 5.9,
      "lat": -22.907326670684288,
      "lng": -43.30887978896499,
      "corrected": true
  },
  {
      "i": "7h021bcmtbs3",
      "h": "A",
      "s": "Itatiaia, RJ - Rod. Pres. Dutra (BR 116) - Km 318",
      "r": 30,
      "p": 14.4,
      "lat": -22.494862429025698,
      "lng": -44.569498244673014,
      "corrected": true
  },
  {
      "i": "7h0b0e8b257e",
      "h": "A",
      "s": "Barra do Piraí, RJ - BR 393 - Km 265",
      "r": 300,
      "p": 6.9,
      "lat": -22.480713299143098,
      "lng": -43.922300320118666,
      "corrected": true
  },
  {
      "i": "7h18qp4yb1zf",
      "h": "A",
      "s": "Cachoeiras de Macacu, RJ - RJ-116 (RJ 116) - Km 48",
      "r": 30,
      "p": 5.6,
      "lat": -22.416474930220495,
      "lng": -42.62327263131738,
      "corrected": true
  },
  {
      "i": "7h1c9h4scexz",
      "h": "A",
      "s": "Nova Friburgo, RJ - RJ 116 - Km 90",
      "r": 100,
      "p": 5.6,
      "lat": -22.213303080004028,
      "lng": -42.49153023585677,
      "corrected": true
  },
  {
      "i": "7h1febc17upt",
      "h": "A",
      "s": "Cordeiro, RJ - RJ 116 - Km 122",
      "r": 100,
      "p": 5.6,
      "lat": -22.056203096600022,
      "lng": -42.37271273508668,
      "corrected": true
  },
  {
      "i": "7h24yuqmpzrf",
      "h": "A",
      "s": "Carmópolis de Minas, MG - Rod. Fernão Dias (BR-381) - Km 585",
      "r": 500,
      "p": 2.1,
      "lat": -20.586133106582327,
      "lng": -44.69442682340741,
      "corrected": true
  },
  {
      "i": "7h2j05c5h184",
      "h": "A",
      "s": "São Sebastião do Oeste, MG - MG 050 - Km 140",
      "r": 1000,
      "p": 5.1,
      "lat": -20.19364415614778,
      "lng": -44.998261760920286,
      "corrected": true
  },
  {
      "i": "7h2ktn67rvzf",
      "h": "A",
      "s": "Itatiaiuçu, MG - Rod. Fernão Dias (BR 381) - Km 535",
      "r": 500,
      "p": 2.1,
      "lat": -20.2682658395473,
      "lng": -44.42380266264081,
      "corrected": true
  },
  {
      "i": "7h2mfxur1bxf",
      "h": "A",
      "s": "Itaúna, MG - MG 050 - Km 81",
      "r": 1000,
      "p": 5.1,
      "lat": -20.039212161396907,
      "lng": -44.53274058178067,
      "corrected": true
  },
  {
      "i": "7h2qepx60h04",
      "h": "A",
      "s": "Florestal/Pará de Minas, MG - BR-262 (BR-262) - Km 389",
      "r": 1000,
      "p": 4.5,
      "lat": -19.909686754245428,
      "lng": -44.506516959518194,
      "corrected": true
  },
  {
      "i": "7h883xqvqe0m",
      "h": "A",
      "s": "Capim Branco, MG - BR-040 (BR-040) - Km 487",
      "r": 1000,
      "p": 5.3,
      "lat": -19.602793323297522,
      "lng": -44.221368972212076,
      "corrected": true
  },
  {
      "i": "6gvjcewmq900",
      "h": "A",
      "s": "Iaras, SP - Rod. Pres. Castelo Branco (SP 280) - Km 278",
      "r": 200,
      "p": 8.5,
      "lat": -22.875083458805136,
      "lng": -49.14450628682971,
      "corrected": true
  },
  {
      "i": "6gvm30cj99py",
      "h": "A",
      "s": "Avaré, SP - Rod. João Mellão (SP 255) - Km 240",
      "r": 100,
      "p": 6.5,
      "lat": -22.978784807832845,
      "lng": -48.821182418614626,
      "corrected": true
  },
  {
      "i": "6gvpzjrszcxu",
      "h": "A",
      "s": "Agudos, SP - Rod. Mal. Rondon (SP 300) - Km 314",
      "r": 300,
      "p": 5.6,
      "lat": -22.513394650078936,
      "lng": -48.9044619910419,
      "corrected": true
  },
  {
      "i": "6gvr5dpm9fpy",
      "h": "A",
      "s": "Areiópolis, SP - Rod. Mal. Rondon (SP 300) - Km 285",
      "r": 500,
      "p": 5.7,
      "lat": -22.663832778086267,
      "lng": -48.70373921468854,
      "corrected": true
  },
  {
      "i": "6gvs8n08wsxf",
      "h": "A",
      "s": "Itatinga, SP - Rod. Pres. Castelo Branco (SP 280) - Km 208",
      "r": 250,
      "p": 12.5,
      "lat": -23.082633821525487,
      "lng": -48.51510750129819,
      "corrected": true
  },
  {
      "i": "6gvtmnwybe00",
      "h": "A",
      "s": "Anhembi, SP - Rod. Mal. Rondon (SP 300) - Km 228",
      "r": 300,
      "p": 7.3,
      "lat": -22.94793387895499,
      "lng": -48.28580779954791,
      "corrected": true
  },
  {
      "i": "6gvw0428gfrb",
      "h": "A",
      "s": "Botucatu, SP - Rod. Mal Rondon (SP 300) - Km 259",
      "r": 200,
      "p": 5.1,
      "lat": -22.83804354602506,
      "lng": -48.51654516533017,
      "corrected": true
  },
  {
      "i": "6gymgwusnbb3",
      "h": "L",
      "s": "Sumaré, SP - Rod. dos Bandeirantes (SP 348) - Km 115",
      "r": 50,
      "p": 7.8,
      "lat": -22.85768396895499,
      "lng": -47.3006428219378,
      "corrected": true
  },
  {
      "i": "6gymgwuy0yxy",
      "h": "O",
      "s": "Sumaré, SP - Rod. dos Bandeirantes (SP 348) - Km 115",
      "r": 50,
      "p": 7.8,
      "lat": -22.857414004940576,
      "lng": -47.30057576671243,
      "corrected": true
  },
  {
      "i": "6gyptpzw39zx",
      "h": "A",
      "s": "Rio Claro, SP - Rod. Cornelio Pires (SP 127) - Km 12",
      "r": 100,
      "p": 5.8,
      "lat": -22.5441607575282,
      "lng": -47.582409884780645,
      "corrected": true
  },
  {
      "i": "6gyqmn9kz38p",
      "h": "S",
      "s": "Nova Odessa, SP - Rod. Anhangüera (SP 330) - Km 118",
      "r": 50,
      "p": 7.8,
      "lat": -22.77100592982809,
      "lng": -47.23907304927707,
      "corrected": true
  },
  {
      "i": "6gyqmn9z3e8p",
      "h": "N",
      "s": "Nova Odessa, SP - Rod. Anhangüera (SP 330) - Km 118",
      "r": 50,
      "p": 7.8,
      "lat": -22.77062045687011,
      "lng": -47.23869754001498,
      "corrected": true
  },
  {
      "i": "6gyr8jb55brg",
      "h": "S",
      "s": "Limeira, SP - Rod. dos Bandeirantes (SP 348) - Km 159",
      "r": 50,
      "p": 5.9,
      "lat": -22.55580473967353,
      "lng": -47.46066005900502,
      "corrected": true
  },
  {
      "i": "6gyr8jb7wdb4",
      "h": "N",
      "s": "Limeira, SP - Rod. dos Bandeirantes (SP 348) - Km 159",
      "r": 50,
      "p": 5.9,
      "lat": -22.55574220190884,
      "lng": -47.46037406846881,
      "corrected": true
  },
  {
      "i": "6gyrbd7yd484",
      "h": "A",
      "s": "Limeira, SP - Rod. Cássio de Freitas Levy (SPV-17) - Km 0",
      "r": 50,
      "p": 2.15,
      "lat": -22.53043159903279,
      "lng": -47.43371861055493,
      "corrected": true
  },
  {
      "i": "6gyrcqnj9f20",
      "h": "S",
      "s": "Limeira, SP - Rod. Anhangüera (SP 330) - Km 152",
      "r": 50,
      "p": 5.9,
      "lat": -22.510021674020177,
      "lng": -47.3976563103497,
      "corrected": true
  },
  {
      "i": "6gyrcqnx1d25",
      "h": "N",
      "s": "Limeira, SP - Rod. Anhangüera (SP 330) - Km 152",
      "r": 50,
      "p": 5.9,
      "lat": -22.50981168761346,
      "lng": -47.39711148664355,
      "corrected": true
  },
  {
      "i": "6uj0308h8w20",
      "h": "A",
      "s": "Piratininga, SP - Rod. Eng. João Baptista Cabral Renno (SP 255) - Km 251",
      "r": 200,
      "p": 5.5,
      "lat": -22.452692272369678,
      "lng": -49.17463084682822,
      "corrected": true
  },
  {
      "i": "6uj351p4ss0m",
      "h": "A",
      "s": "Jaú, SP - Rod. Eng. Paulo Nilo Romano (SP 225) - Km 199",
      "r": 200,
      "p": 10.6,
      "lat": -22.31829638434183,
      "lng": -48.72549729421735,
      "corrected": true
  },
  {
      "i": "6uj9qhmvu2b4",
      "h": "A",
      "s": "Brotas, SP - Rod. Eng. Paulo Nilo Romano (SP 225) - Km 143",
      "r": 200,
      "p": 8.2,
      "lat": -22.255869591017483,
      "lng": -48.24385268613696,
      "corrected": true
  },
  {
      "i": "6ujcmgh915bn",
      "h": "A",
      "s": "Brotas, SP - Rod. Eng. Paulo Nilo Romano (SP 225) - Km 106",
      "r": 100,
      "p": 7.1,
      "lat": -22.263764906251577,
      "lng": -47.9023645631969,
      "corrected": true
  },
  {
      "i": "6ujcy6v4xs0t",
      "h": "A",
      "s": "Itirapina, SP - Rodovia Municipal Ayrton Senna - Km 9,5",
      "r": 100,
      "p": 1.5,
      "lat": -22.176499701580802,
      "lng": -47.88225939497352,
      "corrected": true
  },
  {
      "i": "6ujxnrm1jzzg",
      "h": "A",
      "s": "Jaboticabal , SP - Rod. Atilio Balbo (SP 333) - Km 110",
      "r": 200,
      "p": 12.8,
      "lat": -21.22948448763365,
      "lng": -48.233934212476015,
      "corrected": true
  },
  {
      "i": "6ujzhnmmcx2n",
      "h": "A",
      "s": "Dumont, SP - Estr. Municipal Guido Lorenzato (Estr. Municipal Guido Lorenzato) - Km 0",
      "r": 20,
      "p": 3,
      "lat": -21.23435569786425,
      "lng": -47.980824541300535,
      "corrected": true
  },
  {
      "i": "6ujztdtu9epb",
      "h": "A",
      "s": "Sertãozinho , SP - Rod. Atilio Balbo (SP 322) - Km 327",
      "r": 100,
      "p": 6.5,
      "lat": -21.167021513044535,
      "lng": -47.91438790038228,
      "corrected": true
  },
  {
      "i": "6uk8wf0hpcxf",
      "h": "A",
      "s": "José Bonifácio, SP - Rod. Transbrasiliana (BR 153) - Km 98",
      "r": 200,
      "p": 4.8,
      "lat": -20.997475872008383,
      "lng": -49.62785141542554,
      "corrected": true
  },
  {
      "i": "6ukfvsqchfrv",
      "h": "A",
      "s": "Onda Verde , SP - Rod. Transbrasiliana (BR 153) - Km 35",
      "r": 200,
      "p": 4.8,
      "lat": -20.58680934888201,
      "lng": -49.31904835626483,
      "corrected": true
  },
  {
      "i": "6um04semts86",
      "h": "A",
      "s": "Catiguá , SP - Rod. Washington Luiz (SP 310) - Km 398",
      "r": 200,
      "p": 14.9,
      "lat": -21.068204731212038,
      "lng": -49.10508284345269,
      "corrected": true
  },
  {
      "i": "6um25t5t1s04",
      "h": "A",
      "s": "PIRANGI , SP - Rod. Comendador Pedro Monteleone (SP 351) - Km 184",
      "r": 100,
      "p": 8.9,
      "lat": -21.065376776354263,
      "lng": -48.708570543676615,
      "corrected": true
  },
  {
      "i": "6umnmuhn2481",
      "h": "A",
      "s": "Fronteira/Frutal, MG - BR-153 (BR-153) - Km 227",
      "r": 1000,
      "p": 3.3,
      "lat": -19.97210588221752,
      "lng": -48.96072534844279,
      "corrected": true
  },
  {
      "i": "6un0sqgtxyrt",
      "h": "A",
      "s": "Rio Claro, SP - Rod. Washington Luiz (SP 310) - Km 181",
      "r": 100,
      "p": 8.4,
      "lat": -22.374028367641557,
      "lng": -47.62056430801749,
      "corrected": true
  },
  {
      "i": "6un405e8tcrv",
      "h": "A",
      "s": "Itirapina, SP - Rod. Washington Luiz (SP 310) - Km 217",
      "r": 100,
      "p": 5.1,
      "lat": -22.12896143576567,
      "lng": -47.80804233625531,
      "corrected": true
  },
  {
      "i": "6un5w6cfgbrb",
      "h": "A",
      "s": "Descalvado, SP - Rod. Dr. Paulo Lauro (SP 215) - Km 104",
      "r": 100,
      "p": 6.1,
      "lat": -21.869152948367265,
      "lng": -47.53522815182805,
      "corrected": true
  },
  {
      "i": "6un7049hdj86",
      "h": "A",
      "s": "Pirassununga, SP - Rod. Anhangüera (SP 330) - Km 215",
      "r": 150,
      "p": 7.4,
      "lat": -21.958115964983776,
      "lng": -47.45944702997804,
      "corrected": true
  },
  {
      "i": "6unhu8u2pqxz",
      "h": "A",
      "s": "Santa Rita do Passa Quatro, SP - Rod. Anhangüera (SP 330) - Km 253",
      "r": 100,
      "p": 7.1,
      "lat": -21.660902382682156,
      "lng": -47.60861339047551,
      "corrected": true
  },
  {
      "i": "6unn5ms45t0m",
      "h": "A",
      "s": "São Simão, SP - Rod. Anhangüera (SP 330) - Km 281",
      "r": 100,
      "p": 7.1,
      "lat": -21.414609173091343,
      "lng": -47.66417333856225,
      "corrected": true
  },
  {
      "i": "6unsckkv2025",
      "h": "A",
      "s": "Casa Branca, SP - Rod. Pref. José André de Lima (SP 340) - Km 254",
      "r": 100,
      "p": 5.9,
      "lat": -21.64080991037665,
      "lng": -47.047827523201704,
      "corrected": true
  },
  {
      "i": "6unsefsszzpg",
      "h": "N",
      "s": "Itobi, SP - Rod. Dep. Eduardo Vicente Nasser (SP 350) - Km 252",
      "r": 200,
      "p": 8.8,
      "lat": -21.69453189265986,
      "lng": -46.93785259500146,
      "corrected": true
  },
  {
      "i": "6uq0u56w4tpd",
      "h": "A",
      "s": "Batatais, SP - Rod. Cândido Portinari (SP 334) - Km 334",
      "r": 100,
      "p": 9,
      "lat": -20.94300532235622,
      "lng": -47.633571680635214,
      "corrected": true
  },
  {
      "i": "6uq9mm2ptbxx",
      "h": "A",
      "s": "Pratápolis, MG - MG 050 - Km 389",
      "r": 1000,
      "p": 5.1,
      "lat": -20.84285892247249,
      "lng": -46.87803229317069,
      "corrected": true
  },
  {
      "i": "6ur4057j46pu",
      "h": "A",
      "s": "Passos, MG - MG 050 - Km 333",
      "r": 1000,
      "p": 5.1,
      "lat": -20.723502556718888,
      "lng": -46.40201831236482,
      "corrected": true
  },
  {
      "i": "6ut1rw24g0b2",
      "h": "A",
      "s": "Prata, MG - BR-153 (BR-153) - Km 127",
      "r": 1000,
      "p": 5.6,
      "lat": -19.432964670014265,
      "lng": -48.88904733583331,
      "corrected": true
  },
  {
      "i": "6ut20z3y8400",
      "h": "A",
      "s": "Campo Florido, MG - BR-262 (BR-262) - Km 863",
      "r": 1000,
      "p": 4.9,
      "lat": -19.64652742467688,
      "lng": -48.83180195465684,
      "corrected": true
  },
  {
      "i": "6utepcyj7qrf",
      "h": "A",
      "s": "Uberlândia, MG - BR-050 (BR-050) - Km 104",
      "r": 1000,
      "p": 6.3,
      "lat": -19.149620712901488,
      "lng": -48.16671269014478,
      "corrected": true
  },
  {
      "i": "6gevk1rd3jpv",
      "h": "A",
      "s": "Imbaú, PR - BR 376 - Km 377",
      "r": 500,
      "p": 10.5,
      "lat": -24.38228066348777,
      "lng": -50.79017596319318,
      "corrected": true
  },
  {
      "i": "6gexm2wj51zg",
      "h": "A",
      "s": "Ortigueira, PR - BR 376 - Km 321",
      "r": 500,
      "p": 10.5,
      "lat": -24.034344610201256,
      "lng": -51.08897941187024,
      "corrected": true
  },
  {
      "i": "6gstekb4q181",
      "h": "A",
      "s": "Jaguariaíva, PR - PR 151 - Km 223",
      "r": 500,
      "p": 7.1,
      "lat": -24.31936515586265,
      "lng": -49.77857245132327,
      "corrected": true
  },
  {
      "i": "6gsyzyevss8k",
      "h": "A",
      "s": "Itararé, SP - Rod. Francisco Alves Negrão (SP 258) - Km 326",
      "r": 200,
      "p": 6.3,
      "lat": -24.089579269788164,
      "lng": -49.224227238446474,
      "corrected": true
  },
  {
      "i": "6gtrydhgqxge",
      "h": "A",
      "s": "Buri, SP - Rod. Francisco Alves Negrão (SP 258) - Km 250",
      "r": 200,
      "p": 9.9,
      "lat": -23.93827981132585,
      "lng": -48.5770152322948,
      "corrected": true
  },
  {
      "i": "6gv8nh4ckx2m",
      "h": "A",
      "s": "Capão Bonito, SP - Rod. Prof. Francisco da Silva Pontes (SP 127) - Km 192",
      "r": 200,
      "p": 9.2,
      "lat": -23.8840143691575,
      "lng": -48.24836114421487,
      "corrected": true
  },
  {
      "i": "6gwj1zpz9bzb",
      "h": "A",
      "s": "Juquiá, SP - Rod. Régis Bittencourt (BR 116) - Km 426",
      "r": 1000,
      "p": 3,
      "lat": -24.393820720945286,
      "lng": -47.72494884207845,
      "corrected": true
  },
  {
      "i": "6gybgcbk4wz3",
      "h": "L",
      "s": "Imigrantes - Capital - Rodo Anel Mário Covas (SP-021) - Km 70",
      "r": 10,
      "p": 3.3,
      "lat": -23.764077611755127,
      "lng": -46.592576522380114,
      "corrected": true
  },
  {
      "i": "6gycndtu62pr",
      "h": "L",
      "s": "Ribeirão Pires, SP - Rodo Anel Mário Covas (SP-021) - Km 86",
      "r": 20,
      "p": 3.3,
      "lat": -23.71602835082762,
      "lng": -46.464328709989786,
      "corrected": true
  },
  {
      "i": "6gycndty3mkk",
      "h": "O",
      "s": "Ribeirão Pires, SP - Rodo Anel Mário Covas (SP-021) - Km 86",
      "r": 20,
      "p": 2.5,
      "lat": -23.715639564006167,
      "lng": -46.46420868113637,
      "corrected": true
  },
  {
      "i": "6gycnfcjxt2r",
      "h": "O",
      "s": "Mauá, SP - Rodo Anel Mário Covas (SP-021) - Km 3",
      "r": 50,
      "p": 2.5,
      "lat": -23.714421836127713,
      "lng": -46.45956510677934,
      "corrected": true
  },
  {
      "i": "6gycndqw7f7r",
      "h": "L",
      "s": "Ribeirão Pires, SP - Rodo Anel Mário Covas (SP-021) - Km 86",
      "r": 50,
      "p": 3.3,
      "lat": -23.716905047428092,
      "lng": -46.4633178524673,
      "corrected": true
  },
  {
      "i": "6uttq3bttfr9",
      "h": "A",
      "s": "Araguari, MG - BR-050 (BR-050) - Km 51",
      "r": 1000,
      "p": 4.4,
      "lat": -18.754090688008855,
      "lng": -48.24003120884299,
      "corrected": true
  },
  {
      "i": "6utydy4qg5z8",
      "h": "A",
      "s": "Araguari, MG - BR-050 (BR-050) - Km 13",
      "r": 1000,
      "p": 5.8,
      "lat": -18.510758541521778,
      "lng": -48.038012590259314,
      "corrected": true
  },
  {
      "i": "6uubw2r4pzxg",
      "h": "A",
      "s": "Itumbiara, GO - BR-153 (BR-153) - Km 685",
      "r": 1000,
      "p": 6.3,
      "lat": -18.191568815456147,
      "lng": -49.285576064139605,
      "corrected": true
  },
  {
      "i": "6uy4cmrzkn8w",
      "h": "A",
      "s": "Campo Alegre, MG - BR-050 (BR-050) - Km 226",
      "r": 1000,
      "p": 7.6,
      "lat": -17.767795485314423,
      "lng": -47.74672502651811,
      "corrected": true
  },
  {
      "i": "6uyjcnvu2mrz",
      "h": "A",
      "s": "Ipameri, MG - BR-050 (BR-050) - Km 143",
      "r": 1000,
      "p": 7,
      "lat": -17.23275291211773,
      "lng": -47.76121934875846,
      "corrected": true
  },
  {
      "i": "6vn13suqn580",
      "h": "A",
      "s": "Cristalina, GO - BR-040 (BR-040) - Km 93",
      "r": 1000,
      "p": 5.3,
      "lat": -16.628193440471417,
      "lng": -47.740529123693705,
      "corrected": true
  },
  {
      "i": "75cwzvy2bq8p",
      "h": "A",
      "s": "Rio Bonito, RJ - BR 101 - Km 252",
      "r": 100,
      "p": 5,
      "lat": -22.686903847703096,
      "lng": -42.54021702334285,
      "corrected": true
  },
  {
      "i": "75cy39qbh28q",
      "h": "A",
      "s": "Rio Bonito, RJ - RJ 124 - Km 22",
      "r": 50,
      "p": 11.3,
      "lat": -22.800933642953535,
      "lng": -42.464501950889826,
      "corrected": true
  },
  {
      "i": "7h0zn3nqg587",
      "h": "A",
      "s": "Barbacena, MG - BR-040 (BR-040) - Km 714",
      "r": 1000,
      "p": 5.3,
      "lat": -21.262616296134095,
      "lng": -43.66209486499429,
      "corrected": true
  },
  {
      "i": "7h2cg5t1wgzy",
      "h": "A",
      "s": "Conselheiro Lafaiete, MG - MG-040 (MG-040) - Km 643",
      "r": 1000,
      "p": 5.3,
      "lat": -20.76707445483268,
      "lng": -43.80647214129567,
      "corrected": true
  },
  {
      "i": "7h2sxxv75vpg",
      "h": "A",
      "s": "Itabirito, MG - MG-040 (MG-040) - Km 557",
      "r": 1000,
      "p": 5.3,
      "lat": -20.25967752021218,
      "lng": -43.96007118746638,
      "corrected": true
  },
  {
      "i": "7h404hj9ptbk",
      "h": "A",
      "s": "Casimiro de Abreu, RJ - BR 101 - Km 192",
      "r": 500,
      "p": 5,
      "lat": -22.47578245663448,
      "lng": -42.088696639984846,
      "corrected": true
  },
  {
      "i": "7h46e6hyxvxz",
      "h": "A",
      "s": "Conceição de Macabu, RJ - BR 101 - Km 123",
      "r": 100,
      "p": 5,
      "lat": -22.048402799110274,
      "lng": -41.6861748509109,
      "corrected": true
  },
  {
      "i": "7h4t7kquvmpz",
      "h": "A",
      "s": "Campos de Goytacazes, RJ - BR 101 - Km 40",
      "r": 100,
      "p": 5,
      "lat": -21.552647185896046,
      "lng": -41.331874150782824,
      "corrected": true
  },
  {
      "i": "7h4xssz27d2q",
      "h": "A",
      "s": "Mimoso do Sul, ES - Rod. Governador Mário Covas (BR-101) - Km 451",
      "r": 100,
      "p": 2.3,
      "lat": -21.158378654412132,
      "lng": -41.28054874017835,
      "corrected": true
  },
  {
      "i": "7h6c5zz2jwue",
      "h": "A",
      "s": "Itapemirim, ES - Rod. Governador Mário Covas (BR-101) - Km 398",
      "r": 100,
      "p": 4.2,
      "lat": -20.87535241353173,
      "lng": -40.95781730487943,
      "corrected": true
  },
  {
      "i": "7h75nc5pyts9",
      "h": "A",
      "s": "Guarapari, ES - Rod. Governador Mário Covas (BR-101) - Km 325",
      "r": 100,
      "p": 5,
      "lat": -20.559550757058545,
      "lng": -40.48023188486695,
      "corrected": true
  },
  {
      "i": "7h770u6syfzb",
      "h": "A",
      "s": "Guarapari, ES - Rod. do Sol (ES 060) - Km 30",
      "r": 100,
      "p": 7.2,
      "lat": -20.54234309977414,
      "lng": -40.3929709084332,
      "corrected": true
  },
  {
      "i": "7h7k7jz3emu7",
      "h": "A",
      "s": "Vitória, ES - Terceira Ponte (ES 060) - Km 0",
      "r": 1,
      "p": 0.8,
      "lat": -20.314920777081515,
      "lng": -40.28815219178796,
      "corrected": true
  },
  {
      "i": "7h7q0c0p9c3n",
      "h": "A",
      "s": "Serra, ES - Rod. Governador Mário Covas (BR-101) - Km 242",
      "r": 50,
      "p": 4.8,
      "lat": -20.03242086657831,
      "lng": -40.39663514122367,
      "corrected": true
  },
  {
      "i": "7h870p6tzzzz",
      "h": "A",
      "s": "Curvelo, MG - BR-040 (BR-040) - Km 405",
      "r": 1000,
      "p": 5.3,
      "lat": -19.119266080098484,
      "lng": -44.6446349658072,
      "corrected": true
  },
  {
      "i": "7he2twjc523f",
      "h": "A",
      "s": "Aracruz, ES - Rod. Governador Mário Covas (BR-101) - Km 172",
      "r": 100,
      "p": 5,
      "lat": -19.5631212836758,
      "lng": -40.1775580085814,
      "corrected": true
  },
  {
      "i": "7hesennrn33q",
      "h": "A",
      "s": "São Mateus, ES - Rod. Governador Mário Covas (BR-101) - Km 86",
      "r": 100,
      "p": 5.3,
      "lat": -18.86411710471641,
      "lng": -39.938715007156134,
      "corrected": true
  },
  {
      "i": "7hg8e839ufrg",
      "h": "A",
      "s": "Pedro Canário, ES - Rod. Governador Mário Covas (BR-101) - Km 2",
      "r": 100,
      "p": 4,
      "lat": -18.191721434655403,
      "lng": -39.92184089496732,
      "corrected": true
  },
  {
      "i": "6gzdh0c849u1",
      "h": "A",
      "s": "Paraibuna, SP - Rod. dos Tamoios (SP-099) - Km 59",
      "r": 200,
      "p": 6.5,
      "lat": -23.550506352910535,
      "lng": -45.52513109520078,
      "corrected": true
  },
  {
      "i": "6feu8y90hhup",
      "h": "A",
      "s": "Viamão, RS - RS 040 - Km 19",
      "r": 200,
      "p": 5.2,
      "lat": -30.110749750058144,
      "lng": -50.942097287625074,
      "corrected": true
  },
  {
      "i": "6fex1x7evumc",
      "h": "L",
      "s": "Portão, RS - RS-240 - Km 13",
      "r": 20,
      "p": 4.8,
      "lat": -29.66656787165428,
      "lng": -51.257163640111685,
      "corrected": true
  },
  {
      "i": "6fex1x7vpw01",
      "h": "L",
      "s": "Portão, RS - RS-122 - Km 0",
      "r": 20,
      "p": 4.8,
      "lat": -29.66633662404208,
      "lng": -51.25683842226863,
      "corrected": true
  },
  {
      "i": "6fexm9jtj2xs",
      "h": "A",
      "s": "Campo Bom, RS - RS-239 - Km 19",
      "r": 50,
      "p": 2.4,
      "lat": -29.65684757261488,
      "lng": -51.079050209373236,
      "corrected": true
  },
  {
      "i": "6fg95xtnt586",
      "h": "A",
      "s": "Caxias do Sul, RS - BR 116 - Km 171",
      "r": 100,
      "p": 6,
      "lat": -29.312985344563653,
      "lng": -51.16733143106103,
      "corrected": true
  },
  {
      "i": "6gfgt6112hbp",
      "h": "A",
      "s": "Castelo Branco, PR - BR 376 - Km 148",
      "r": 100,
      "p": 11.1,
      "lat": -23.279844650173892,
      "lng": -52.15075297281146,
      "corrected": true
  },
  {
      "i": "6gut0k28zgxz",
      "h": "A",
      "s": "Jacarezinho, PR - BR 369 - Km 1",
      "r": 400,
      "p": 19.3,
      "lat": -23.003971235240066,
      "lng": -49.9098457954824,
      "corrected": true
  },
  {
      "i": "6gutu8e4ys0h",
      "h": "A",
      "s": "Ourinhos, SP - Rod. Orlando Quagliato (SP 327) - Km 14",
      "r": 200,
      "p": 6.4,
      "lat": -22.892288570472648,
      "lng": -49.71971472725272,
      "corrected": true
  },
  {
      "i": "6guyd40uq6rv",
      "h": "A",
      "s": "Sta. Cruz do Rio Pardo, SP - Rod. Eng João Baptista Cabral Renno (SP 255) - Km 300",
      "r": 200,
      "p": 5.2,
      "lat": -22.751941138947583,
      "lng": -49.48112217709422,
      "corrected": true
  },
  {
      "i": "6gwzy9yntgry",
      "h": "N",
      "s": "São Vicente, SP - Rod. Padre Manuel da Nóbrega (SP-055) - Km 279",
      "r": 150,
      "p": 7,
      "lat": -23.939403825940808,
      "lng": -46.46366687491536,
      "corrected": true
  },
  {
      "i": "6gyb7zxdhj8n",
      "h": "S",
      "s": "São Bernardo do Campo, SP - Rod. dos Imigrantes (SP 160) - Km 32",
      "r": 150,
      "p": 25.6,
      "lat": -23.820748296233045,
      "lng": -46.58272309228778,
      "corrected": true
  },
  {
      "i": "6gybg9xknr5b",
      "h": "L",
      "s": "Imigrantes - Litoral - Rodo Anel Mário Covas (SP-021) - Km 70",
      "r": 20,
      "p": 3.3,
      "lat": -23.765464764744273,
      "lng": -46.59390790387988,
      "corrected": true
  },
  {
      "i": "6gybgeyrew86",
      "h": "S",
      "s": "São Bernardo do Campo, SP - Rod. dos Imigrantes (SP 160) - Km 24",
      "r": 10,
      "p": 5.8,
      "lat": -23.752355696015638,
      "lng": -46.595240626484156,
      "corrected": true
  },
  {
      "i": "6gybtmmds9ps",
      "h": "S",
      "s": "São Bernardo do Campo, SP - Rod. Anchieta (SP 150) - Km 31",
      "r": 150,
      "p": 25.6,
      "lat": -23.789240840617452,
      "lng": -46.51959193870425,
      "corrected": true
  },
  {
      "i": "6gybu1bmees2",
      "h": "O",
      "s": "Imigrantes - Rodo Anel Mário Covas (SP-021) - Km 71",
      "r": 10,
      "p": 3.3,
      "lat": -23.763861349092565,
      "lng": -46.58136723563075,
      "corrected": true
  },
  {
      "i": "6gybugjpfwhn",
      "h": "N",
      "s": "Anchieta - Rodo Anel Mário Covas (SP-021) - Km 75",
      "r": 30,
      "p": 3.3,
      "lat": -23.756481927141195,
      "lng": -46.54208494350314,
      "corrected": true
  },
  {
      "i": "6gyc56q8d81c",
      "h": "S",
      "s": "Diadema, SP - Rod. dos Imigrantes (SP 160) - Km 20",
      "r": 15,
      "p": 3.6,
      "lat": -23.718034713094518,
      "lng": -46.60594532266259,
      "corrected": true
  },
  {
      "i": "6gyc72fbpygf",
      "h": "S",
      "s": "Diadema, SP - Rod. dos Imigrantes (SP 160) - Km 15",
      "r": 20,
      "p": 1.8,
      "lat": -23.68161529635125,
      "lng": -46.611224580556154,
      "corrected": true
  },
  {
      "i": "6gz04659z623",
      "h": "N",
      "s": "Santos, SP - Rod. Cônego Domênico Rangoni (SP 055) - Km 250",
      "r": 150,
      "p": 12,
      "lat": -23.894904349056173,
      "lng": -46.30219588056207,
      "corrected": true
  },
  {
      "i": "6gz48b55rbpv",
      "h": "A",
      "s": "Itaquaquecetuba, SP - Rod. Ayrton Senna da Silva (SP 070) - Km 32",
      "r": 65,
      "p": 3.6,
      "lat": -23.466246664833378,
      "lng": -46.368621457368135,
      "corrected": true
  },
  {
      "i": "6gz493t1xu2h",
      "h": "L",
      "s": "Itaquaquecetuba, SP - SP-021 (SP-021) - Km 124",
      "r": 15,
      "p": 2.5,
      "lat": -23.458315144521475,
      "lng": -46.344323325902224,
      "corrected": true
  },
  {
      "i": "6gz49pdetmb4",
      "h": "N",
      "s": "Arujá, SP - SP-021 (SP-021) - Km 128",
      "r": 10,
      "p": 2.5,
      "lat": -23.424974679221453,
      "lng": -46.358684208244085,
      "corrected": true
  },
  {
      "i": "6gz4c1bckj2h",
      "h": "A",
      "s": "Arujá, SP - Rod. Pres. Dutra (BR 116) - Km 204",
      "r": 50,
      "p": 3.5,
      "lat": -23.413018414098076,
      "lng": -46.36106936261058,
      "corrected": true
  },
  {
      "i": "6uh8btbc2hbr",
      "h": "A",
      "s": "Marília, SP - Rod. Transbrasiliana (RB 153) - Km 268",
      "r": 100,
      "p": 4.8,
      "lat": -22.336335193428393,
      "lng": -49.89886851981282,
      "corrected": true
  },
  {
      "i": "6uhczs3mjcrt",
      "h": "A",
      "s": "Avaí, SP - Rod. Mal. Rondon (SP 300) - Km 367",
      "r": 100,
      "p": 5.3,
      "lat": -22.168071573141084,
      "lng": -49.23868468031287,
      "corrected": true
  },
  {
      "i": "6uhg4j63yn23",
      "h": "A",
      "s": "Pirajuí, SP - Rod. Mal. Rondon (SP 300) - Km 400",
      "r": 200,
      "p": 4.9,
      "lat": -21.943696910640252,
      "lng": -49.47922417894006,
      "corrected": true
  },
  {
      "i": "6ujm3y1dtgzz",
      "h": "A",
      "s": "Itápolis , SP - Rod. Laurentino Mascari (SP 333) - Km 179",
      "r": 100,
      "p": 7.1,
      "lat": -21.543626658740934,
      "lng": -48.78799008205533,
      "corrected": true
  },
  {
      "i": "6ujq7569wcxv",
      "h": "A",
      "s": "Agulha, SP - Rod. Washington Luiz (SP 310) - Km 346",
      "r": 100,
      "p": 10.6,
      "lat": -21.383095591603023,
      "lng": -48.731532264500856,
      "corrected": true
  },
  {
      "i": "6ujrp5dh3r0n",
      "h": "A",
      "s": "Monte Alto, SP - Rod. Orlando Chesini Ometto (SP-323) - Km 19",
      "r": 200,
      "p": 5.7,
      "lat": -21.24945572928079,
      "lng": -48.55672365054488,
      "corrected": true
  },
  {
      "i": "6ujxff59gp84",
      "h": "A",
      "s": "Taiúva, SP - Rod. Brg. Faria Lima (SP 326) - Km 357",
      "r": 100,
      "p": 7.5,
      "lat": -21.12640983208578,
      "lng": -48.38992914184928,
      "corrected": true
  },
  {
      "i": "6um8rxqee8rb",
      "h": "A",
      "s": "Pitangueiras, SP - Rod. Armando Sales Oliveira (SP 322) - Km 361",
      "r": 200,
      "p": 8.5,
      "lat": -21.00925431712954,
      "lng": -48.17672135308385,
      "corrected": true
  },
  {
      "i": "6umcqh5qz5bj",
      "h": "A",
      "s": "Sales Oliveira , SP - Rod. Anhanguera (SP 330) - Km 350",
      "r": 100,
      "p": 10.7,
      "lat": -20.85087729475646,
      "lng": -47.895559798926115,
      "corrected": true
  },
  {
      "i": "6umupczhsx8p",
      "h": "A",
      "s": "Ituverava, SP - Rod. Anhanguera (SP 330) - Km 405",
      "r": 100,
      "p": 13.1,
      "lat": -20.380353883363863,
      "lng": -47.813561987131834,
      "corrected": true
  },
  {
      "i": "6umyxub2q900",
      "h": "A",
      "s": "Delta, MG - BR-050 (BR-050) - Km 198",
      "r": 1000,
      "p": 4.5,
      "lat": -19.925027199646458,
      "lng": -47.82286053523421,
      "corrected": true
  },
  {
      "i": "6uq4nvnsz0zx",
      "h": "A",
      "s": "Restinga, SP - Rod. Cândido Portinari (SP 334) - Km 374",
      "r": 100,
      "p": 9,
      "lat": -20.7140013605673,
      "lng": -47.50605275854468,
      "corrected": true
  },
  {
      "i": "6uw0qb55h92j",
      "h": "A",
      "s": "Sacramento, MG - BR-262 (BR-262) - Km 736",
      "r": 1000,
      "p": 5.9,
      "lat": -19.643029233953886,
      "lng": -47.51155665144324,
      "corrected": true
  },
  {
      "i": "6fdx0kvbyyzu",
      "h": "A",
      "s": "Candelária, RS - BR-287 (RSC-287) - Km 131",
      "r": 100,
      "p": 5.2,
      "lat": -29.680668729628106,
      "lng": -52.71514439955354,
      "corrected": true
  },
  {
      "i": "6fept44z880k",
      "h": "A",
      "s": "Fazenda Vilanova , RS - BR 386 (BR 386) - Km 370",
      "r": 100,
      "p": 6,
      "lat": -29.606908058318247,
      "lng": -51.807714868336916,
      "corrected": true
  },
  {
      "i": "6ffqvu9cqq2r",
      "h": "A",
      "s": "Sta Barbara Sul, RS - BR 285 - Km 341",
      "r": 100,
      "p": 0,
      "lat": -28.319564935497045,
      "lng": -52.83060209825635,
      "corrected": true
  },
  {
      "i": "6ffrtcgfe102",
      "h": "A",
      "s": "Sarandi, RS - BR 386 - Km 164",
      "r": 500,
      "p": 0,
      "lat": -28.202840031489664,
      "lng": -52.82792491838336,
      "corrected": true
  },
  {
      "i": "6ffsn05cq8xs",
      "h": "A",
      "s": "Soledade, RS - BR 386 - Km 248",
      "r": 100,
      "p": 0,
      "lat": -28.8279460522496,
      "lng": -52.46531976386905,
      "corrected": true
  },
  {
      "i": "6ffx1m2gmx8q",
      "h": "A",
      "s": "Passo Fundo, RS - BR-285 (BR 285) - Km 326",
      "r": 100,
      "p": 0,
      "lat": -28.271143895822807,
      "lng": -52.67840417101979,
      "corrected": true
  },
  {
      "i": "6ffzc9pnuzrg",
      "h": "N",
      "s": "Passo Fundo – Erexim, RS - RS-135 (ERS-135) - Km 18",
      "r": 100,
      "p": 3.6,
      "lat": -28.16289891842132,
      "lng": -52.30763101950288,
      "corrected": true
  },
  {
      "i": "6fg30ev81d8m",
      "h": "A",
      "s": "Boa Vista do Sul, RS - RS-453 (RSC 453) - Km 18",
      "r": 100,
      "p": 5.2,
      "lat": -29.33480244055255,
      "lng": -51.65006501600146,
      "corrected": true
  },
  {
      "i": "6fg9bf3e60b1",
      "h": "A",
      "s": "Farroupilha, RS - RS 122 - Km 65",
      "r": 150,
      "p": 0,
      "lat": -29.210434767194688,
      "lng": -51.293103229254484,
      "corrected": true
  },
  {
      "i": "6fgdvhk6ybze",
      "h": "A",
      "s": "São Marcos, RS - Estr. P/ Caxias (BR 116) - Km 126",
      "r": 100,
      "p": 6,
      "lat": -29.024202786606235,
      "lng": -51.102221477776766,
      "corrected": true
  },
  {
      "i": "6fge536r8zxb",
      "h": "A",
      "s": "Flores da Cunha, RS - RS-122 (ERS 122) - Km 100",
      "r": 100,
      "p": 5.2,
      "lat": -28.995678880241446,
      "lng": -51.182107385247946,
      "corrected": true
  },
  {
      "i": "6gkvtwrrg020",
      "h": "A",
      "s": "Fazenda Rio Grande, PR - Rod. Régis Bittencourt (BR-116) - Km 134",
      "r": 200,
      "p": 5.6,
      "lat": -25.714833071063357,
      "lng": -49.31821083649993,
      "corrected": true
  },
  {
      "i": "6gmjd0bwcyzz",
      "h": "A",
      "s": "São José dos Pinhais, PR - BR 376 - Km 637",
      "r": 300,
      "p": 2.6,
      "lat": -25.745134353006176,
      "lng": -49.130049515515566,
      "corrected": true
  },
  {
      "i": "6gmnshku8v23",
      "h": "A",
      "s": "São José dos Pinhais, PR - Rod. Curitiba Paranaguá (BR 277) - Km 60",
      "r": 200,
      "p": 18.7,
      "lat": -25.551935501555885,
      "lng": -49.03692523017526,
      "corrected": true
  },
  {
      "i": "6gt9fyxgjypb",
      "h": "A",
      "s": "Barra do Turvo, SP - Rod. Régis Bittencourt (BR-116) - Km 542",
      "r": 500,
      "p": 3,
      "lat": -24.96881965060975,
      "lng": -48.383966255933046,
      "corrected": true
  },
  {
      "i": "6gtg3g7m4dpb",
      "h": "A",
      "s": "Cajati, SP - Rod. Régis Bittencourt (BR 116) - Km 485",
      "r": 150,
      "p": 3,
      "lat": -24.723222379578125,
      "lng": -48.084972370415926,
      "corrected": true
  },
  {
      "i": "6gwqe44n612j",
      "h": "A",
      "s": "Miracatu, SP - Rod. Régis Bittencourt (BR-116) - Km 370",
      "r": 500,
      "p": 3,
      "lat": -24.156469853657462,
      "lng": -47.32551259920001,
      "corrected": true
  },
  {
      "i": "6gy8u2rx08b0",
      "h": "A",
      "s": "São Lourenço da Serra, SP - Rod. Régis Bittencourt (BR 116) - Km 298",
      "r": 100,
      "p": 3,
      "lat": -23.771914810646173,
      "lng": -46.91221101209521,
      "corrected": true
  },
  {
      "i": "6gy8xyu37brg",
      "h": "N",
      "s": "Parelheiros, SP - Rodo Anel Mário Covas (SP-021) - Km 50",
      "r": 100,
      "p": 3.3,
      "lat": -23.781005105709983,
      "lng": -46.7628981359303,
      "corrected": true
  },
  {
      "i": "6gy9wz8pbnen",
      "h": "S",
      "s": "São Paulo, SP - Rodo Anel Mário Covas (SP 021) - Km 25",
      "r": 100,
      "p": 2,
      "lat": -23.599960216147817,
      "lng": -46.81277213618159,
      "corrected": true
  },
  {
      "i": "6gy9ybcbtg00",
      "h": "N",
      "s": "São Paulo, SP - Rodo Anel Mário Covas (SP 021) - Km 24",
      "r": 30,
      "p": 2,
      "lat": -23.594405093986243,
      "lng": -46.81010166183114,
      "corrected": true
  },
  {
      "i": "6gy9yc9ugk2m",
      "h": "S",
      "s": "São Paulo, SP - Rodo Anel Mário Covas (SP 021) - Km 24",
      "r": 30,
      "p": 2,
      "lat": -23.588368236188327,
      "lng": -46.80974727496505,
      "corrected": true
  },
  {
      "i": "6gy9yxexy88n",
      "h": "N",
      "s": "Padroeira Externa, SP - Rodo Anel Mário Covas (SP 021) - Km 20",
      "r": 30,
      "p": 2,
      "lat": -23.564491818888413,
      "lng": -46.819177251309156,
      "corrected": true
  },
  {
      "i": "6gyd5ydv0hzb",
      "h": "O",
      "s": "Itapevi , SP - Rod. Pres. Castelo Branco (SP 280) - Km 33",
      "r": 250,
      "p": 8.2,
      "lat": -23.51805871135695,
      "lng": -46.939280200749636,
      "corrected": true
  },
  {
      "i": "6gydn867j8zc",
      "h": "S",
      "s": "São Paulo, SP - Rodo Anel Mário Covas (SP 021) - Km 19",
      "r": 30,
      "p": 2,
      "lat": -23.552017979549948,
      "lng": -46.82043956592679,
      "corrected": true
  },
  {
      "i": "6gydnwxk4y84",
      "h": "N",
      "s": "São Paulo, SP - Rodo Anel Mário Covas (SP 021) - Km 15",
      "r": 50,
      "p": 2,
      "lat": -23.51796917521436,
      "lng": -46.81374343112111,
      "corrected": true
  },
  {
      "i": "6gydppb60db4",
      "h": "O",
      "s": "Osasco, SP - Rod. Pres. Castelo Branco (SP 280) - Km 18",
      "r": 100,
      "p": 4.1,
      "lat": -23.51191439416895,
      "lng": -46.80140359327197,
      "corrected": true
  },
  {
      "i": "6gydq88btxpz",
      "h": "O",
      "s": "São Paulo, SP - Rodo Anel Mário Covas (SP 021) - Km 14",
      "r": 30,
      "p": 2,
      "lat": -23.50806281521718,
      "lng": -46.82328002527356,
      "corrected": true
  },
  {
      "i": "6gydq8hdtmzx",
      "h": "L",
      "s": "Barueri, SP - Rod. Pres. Castelo Branco (SP 280) - Km 20",
      "r": 100,
      "p": 4.1,
      "lat": -23.50999439291708,
      "lng": -46.817269530147314,
      "corrected": true
  },
  {
      "i": "6f6duxr45f2h",
      "h": "A",
      "s": "Capão do Leão, RS - BR-116 - Km 541",
      "r": 100,
      "p": 10.7,
      "lat": -31.8201007485315,
      "lng": -52.52673799172044,
      "corrected": true
  },
  {
      "i": "6f6fc393rq84",
      "h": "A",
      "s": "Rio Grande, RS - BR 392 - Km 52",
      "r": 150,
      "p": 10.7,
      "lat": -31.85208294763411,
      "lng": -52.326017897576094,
      "corrected": true
  },
  {
      "i": "6f6t44u0z224",
      "h": "A",
      "s": "Canguçu, RS - BR 392 - Km 111",
      "r": 150,
      "p": 10.7,
      "lat": -31.449661101089173,
      "lng": -52.640713434666395,
      "corrected": true
  },
  {
      "i": "6f6u16yfjyz9",
      "h": "A",
      "s": "Pelotas, RS - BR-116 - Km 510",
      "r": 100,
      "p": 10.7,
      "lat": -31.62526976756592,
      "lng": -52.31822540983558,
      "corrected": true
  },
  {
      "i": "6f6zrxgh4x8q",
      "h": "A",
      "s": "Cristal, RS - BR-116 - Km 430",
      "r": 200,
      "p": 10.7,
      "lat": -31.02625803750489,
      "lng": -52.04956194385886,
      "corrected": true
  },
  {
      "i": "6fdsnjs5jmzu",
      "h": "A",
      "s": "Pântano Grande, RS - BR 290 - Km 224",
      "r": 100,
      "p": 0,
      "lat": -30.203537778502138,
      "lng": -52.46497543528676,
      "corrected": true
  },
  {
      "i": "6fdwpxws4dry",
      "h": "A",
      "s": "Rio Pardo, RS - BR 471 - Km 139",
      "r": 2000,
      "p": 6,
      "lat": -29.84278800371179,
      "lng": -52.395087126642466,
      "corrected": true
  },
  {
      "i": "6fdz4rhkwvps",
      "h": "A",
      "s": "Venâncio Aires, RS - BR-287 (RSC-287) - Km 86",
      "r": 100,
      "p": 5.2,
      "lat": -29.66770796563316,
      "lng": -52.27777099236846,
      "corrected": true
  },
  {
      "i": "6ffbnc8sbmxd",
      "h": "A",
      "s": "Cruzeiro do Sul, RS - RS-453 (RSC 453) - Km 18",
      "r": 100,
      "p": 5.2,
      "lat": -29.52216260500658,
      "lng": -52.08564838394523,
      "corrected": true
  },
  {
      "i": "6ffcq25eh5b4",
      "h": "A",
      "s": "Marques de Souza, RS - BR 386 (BR 386) - Km 312",
      "r": 200,
      "p": 12,
      "lat": -29.31103352469188,
      "lng": -52.102926168590784,
      "corrected": true
  },
  {
      "i": "6fg16uzf9n2r",
      "h": "A",
      "s": "Encantado , RS - RS 130 (RS 130) - Km 93",
      "r": 400,
      "p": 5.2,
      "lat": -29.284960828894388,
      "lng": -51.89970726147294,
      "corrected": true
  },
  {
      "i": "6fgtrx9zwn02",
      "h": "A",
      "s": "Vacaria, RS - BR 116 - Km 48",
      "r": 100,
      "p": 0,
      "lat": -28.56587673729202,
      "lng": -50.99597180262208,
      "corrected": true
  },
  {
      "i": "6fgwpsgyvs0h",
      "h": "A",
      "s": "Vacaria, RS - BR 285 - Km 130",
      "r": 200,
      "p": 0,
      "lat": -28.44938750347012,
      "lng": -50.99325506016612,
      "corrected": true
  },
  {
      "i": "6fgye0c5u0rv",
      "h": "A",
      "s": "Vacaria, RS - BR 116 - Km 22",
      "r": 200,
      "p": 0,
      "lat": -28.383893324967197,
      "lng": -50.84339199587703,
      "corrected": true
  },
  {
      "i": "6gh4w85j48r9",
      "h": "A",
      "s": "Correia Pinto, SC - BR 116 - Km 233",
      "r": 200,
      "p": 5.6,
      "lat": -27.684684600409714,
      "lng": -50.33503694459796,
      "corrected": true
  },
  {
      "i": "6ghnheb7ksxb",
      "h": "A",
      "s": "Santa Cecília, SC - BR 116 - Km 152",
      "r": 200,
      "p": 5.6,
      "lat": -27.049083235166595,
      "lng": -50.426571015268564,
      "corrected": true
  },
  {
      "i": "6gk2c5jb272p",
      "h": "A",
      "s": "Monte Castelo, SC - BR 116 - Km 81",
      "r": 200,
      "p": 5.6,
      "lat": -26.570351372958893,
      "lng": -50.22145880386233,
      "corrected": true
  },
  {
      "i": "6gkesj9bhm8h",
      "h": "A",
      "s": "Rio Negro, PR - Rod. Régis Bittencourt (BR 116) - Km 204",
      "r": 100,
      "p": 5.6,
      "lat": -26.073275975545563,
      "lng": -49.74350793287158,
      "corrected": true
  },
  {
      "i": "6gktth9wwp05",
      "h": "A",
      "s": "Lapa, PR - BR 476 - Km 192",
      "r": 50,
      "p": 12.2,
      "lat": -25.726049443721678,
      "lng": -49.69982514157891,
      "corrected": true
  },
  {
      "i": "6gkx07sus9b3",
      "h": "A",
      "s": "Porto Amazonas, PR - BR 277 - Km 158",
      "r": 100,
      "p": 12.2,
      "lat": -25.468330269771474,
      "lng": -49.90419873967767,
      "corrected": true
  },
  {
      "i": "6gkxcc2xvypx",
      "h": "A",
      "s": "Palmeira, PR - BR 376 - Km 537",
      "r": 500,
      "p": 11.3,
      "lat": -25.347005469424904,
      "lng": -49.84297966584563,
      "corrected": true
  },
  {
      "i": "6gkxjgj4mbb4",
      "h": "A",
      "s": "Balsa Nova, PR - BR 277 - Km 132",
      "r": 150,
      "p": 7.9,
      "lat": -25.471721028683152,
      "lng": -49.66401932761073,
      "corrected": true
  },
  {
      "i": "6gt0nkp2mypc",
      "h": "A",
      "s": "Campina Grande do Sul, PR - Rod. Régis Bittencourt (BR-116) - Km 57",
      "r": 300,
      "p": 3,
      "lat": -25.290569609156883,
      "lng": -48.93417315557599,
      "corrected": true
  },
  {
      "i": "6g3r6gj77rrg",
      "h": "A",
      "s": "São Miguel do Iguaçu, PR - BR 277 - Km 704",
      "r": 200,
      "p": 14.8,
      "lat": -25.427316901535647,
      "lng": -54.36453798785806,
      "corrected": true
  },
  {
      "i": "6g6xv99pdvzc",
      "h": "A",
      "s": "Laranjeiras do Sul, PR - BR 277 - Km 464",
      "r": 100,
      "p": 12.2,
      "lat": -25.346941549195414,
      "lng": -52.49127248302102,
      "corrected": true
  },
  {
      "i": "6g7p7bj5ddb4",
      "h": "A",
      "s": "Candói, PR - BR 277 - Km 388",
      "r": 100,
      "p": 12.2,
      "lat": -25.443702088775503,
      "lng": -51.8594560213387,
      "corrected": true
  },
  {
      "i": "6g7zmct232pz",
      "h": "A",
      "s": "Irati, PR - BR 277 - Km 249",
      "r": 100,
      "p": 10.7,
      "lat": -25.43600296902082,
      "lng": -50.71637498214841,
      "corrected": true
  },
  {
      "i": "6gc25vfd5gxz",
      "h": "A",
      "s": "Mundo Novo, MS - BR-163 (BR-163) - Km 28",
      "r": 1000,
      "p": 4.6,
      "lat": -23.874290833719847,
      "lng": -54.32371510192752,
      "corrected": true
  },
  {
      "i": "6gckneu9pfpz",
      "h": "A",
      "s": "Itaquiraí, MS - BR-163 (BR-163) - Km 113",
      "r": 1000,
      "p": 6.5,
      "lat": -23.182341370857475,
      "lng": -54.20014875009656,
      "corrected": true
  },
  {
      "i": "6ge858s2fezg",
      "h": "A",
      "s": "Prudentópolis, PR - BR 277 - Km 302",
      "r": 100,
      "p": 12.2,
      "lat": -25.309619729484435,
      "lng": -51.16834161803126,
      "corrected": true
  },
  {
      "i": "6gj6ktvg3hzw",
      "h": "A",
      "s": "Palhoça, SC - BR 101 - Km 220",
      "r": 100,
      "p": 2.6,
      "lat": -27.697341022983096,
      "lng": -48.66151923313737,
      "corrected": true
  },
  {
      "i": "6gjmmf3kje00",
      "h": "A",
      "s": "Porto Belo, SC - BR 101 - Km 159",
      "r": 200,
      "p": 2.6,
      "lat": -27.188978036732614,
      "lng": -48.61243648454547,
      "corrected": true
  },
  {
      "i": "6gm2er6jvh20",
      "h": "A",
      "s": "Araquari, SC - BR 101 - Km 79",
      "r": 300,
      "p": 2.6,
      "lat": -26.59000960892708,
      "lng": -48.72182099148631,
      "corrected": true
  },
  {
      "i": "6gmhpsmcbupc",
      "h": "A",
      "s": "Garuva, SC - BR 101 - Km 1",
      "r": 300,
      "p": 2.6,
      "lat": -25.99280557645257,
      "lng": -48.880866933614016,
      "corrected": true
  },
  {
      "i": "6gs0cu78dh0k",
      "h": "A",
      "s": "Imbituva, PR - BR 373 - Km 217",
      "r": 100,
      "p": 10.7,
      "lat": -25.156968507407463,
      "lng": -50.54177859798074,
      "corrected": true
  },
  {
      "i": "6gs4hytpwypz",
      "h": "A",
      "s": "Tibagi, PR - BR 376 - Km 457",
      "r": 500,
      "p": 10.5,
      "lat": -24.923842009816163,
      "lng": -50.408978406339884,
      "corrected": true
  },
  {
      "i": "6gs6k0zfv4xu",
      "h": "A",
      "s": "Carambeí, PR - PR 151 - Km 304",
      "r": 200,
      "p": 9.4,
      "lat": -24.912231303595654,
      "lng": -50.086793806403875,
      "corrected": true
  },
  {
      "i": "6sx1j15j3yru",
      "h": "A",
      "s": "Porto Morrinhos, MS - BR-262 - Km 714",
      "r": 2500,
      "p": 8.5,
      "lat": -19.50527712429499,
      "lng": -57.43231588974595,
      "corrected": true
  },
  {
      "i": "6u0bp6xu8xpb",
      "h": "A",
      "s": "Caarapó, MS - BR-163 (BR-163) - Km 277",
      "r": 1000,
      "p": 6.5,
      "lat": -22.485469370394,
      "lng": -54.86618148162961,
      "corrected": true
  },
  {
      "i": "6u15x28sknb1",
      "h": "A",
      "s": "Rio Brilhante, MS - BR-163 (BR-163) - Km 313",
      "r": 1000,
      "p": 6.6,
      "lat": -21.88125053185993,
      "lng": -54.5243332721293,
      "corrected": true
  },
  {
      "i": "6u31pfc6pbpz",
      "h": "A",
      "s": "Campo Grande, MS - BR-163 (BR-163) - Km 432",
      "r": 1000,
      "p": 7.4,
      "lat": -20.902528617969224,
      "lng": -54.50117575004697,
      "corrected": true
  },
  {
      "i": "6u3mcegx8j84",
      "h": "A",
      "s": "Jaraguarí, MS - BR-163 (BR-163) - Km 533",
      "r": 1000,
      "p": 5.6,
      "lat": -20.06107216749964,
      "lng": -54.42177465185523,
      "corrected": true
  },
  {
      "i": "6u9305wczvxs",
      "h": "A",
      "s": "São Gabriel do Oeste, MS - BR-163 (BR-163) - Km 603",
      "r": 1000,
      "p": 5.5,
      "lat": -19.492078569708863,
      "lng": -54.482047241181135,
      "corrected": true
  },
  {
      "i": "6u9j2e91b42j",
      "h": "A",
      "s": "Rio Verde de Mato Grosso, MS - BR-163 (BR-163) - Km 703",
      "r": 1000,
      "p": 7.3,
      "lat": -18.74508927940009,
      "lng": -54.82088869437575,
      "corrected": true
  },
  {
      "i": "6v80g896upbh",
      "h": "A",
      "s": "Nova Mutum, MT - BR-163 (BR-163) - Km 586",
      "r": 100,
      "p": 3.8,
      "lat": -13.927382256221964,
      "lng": -56.09441293403506,
      "corrected": true
  },
  {
      "i": "6v81kv3wun04",
      "h": "A",
      "s": "Nova Mutum, MT - MT-235 - Km 103",
      "r": 15,
      "p": 6.1,
      "lat": -13.81277784336842,
      "lng": -56.03900285437703,
      "corrected": true
  },
  {
      "i": "6trbu0cfnxbp",
      "h": "A",
      "s": "Jangada, MT - BR-163 (BR-163) - Km 398",
      "r": 1000,
      "p": 5.5,
      "lat": -15.332386694536094,
      "lng": -56.42303315922618,
      "corrected": true
  },
  {
      "i": "6uc4drknxupx",
      "h": "A",
      "s": "Pedro Gomes, MS - BR-163 (BR-163) - Km 817",
      "r": 1000,
      "p": 5.4,
      "lat": -17.800821429547142,
      "lng": -54.73897872492671,
      "corrected": true
  },
  {
      "i": "6ucn1btu01bj",
      "h": "A",
      "s": "Itiquira, MT - BR-163 (BR-163) - Km 33",
      "r": 1000,
      "p": 4.5,
      "lat": -17.223123125865953,
      "lng": -54.75889479741454,
      "corrected": true
  },
  {
      "i": "6v0q9td1qyps",
      "h": "A",
      "s": "Santo Antônio de Levenger, MT - BR-163 (BR-163) - Km 302",
      "r": 1000,
      "p": 4.1,
      "lat": -15.701920318436867,
      "lng": -55.82950925454497,
      "corrected": true
  },
  {
      "i": "6v0wj3y89sz8",
      "h": "A",
      "s": "Campo Verde, MT - BR-163 (BR-163) - Km 235",
      "r": 1000,
      "p": 4.1,
      "lat": -15.809817394008167,
      "lng": -55.30602587386966,
      "corrected": true
  },
  {
      "i": "6v14dzwksy8k",
      "h": "A",
      "s": "Rondonópolis, MT - BR-163 (BR-163) - Km 133",
      "r": 1000,
      "p": 5.1,
      "lat": -16.393689288814826,
      "lng": -54.71415152773261,
      "corrected": true
  },
  {
      "i": "6v14vzx4cyb5",
      "h": "A",
      "s": "Rondonópolis, MT - MT-130 (MT-130) - Km 9",
      "r": 1000,
      "p": 7.4,
      "lat": -16.349893966689695,
      "lng": -54.58137480542064,
      "corrected": true
  },
  {
      "i": "6v1r66bzrqwr",
      "h": "A",
      "s": "Primavera do Leste, MT - MT-130 (MT-130) - Km 111",
      "r": 1000,
      "p": 7.4,
      "lat": -15.58420100304414,
      "lng": -54.39195955172181,
      "corrected": true
  },
  {
      "i": "6v2hbr73680n",
      "h": "A",
      "s": "Diamantino, MT - BR-163 (BR-163) - Km 498",
      "r": 100,
      "p": 4.6,
      "lat": -14.59384269868663,
      "lng": -56.234313268214464,
      "corrected": true
  },
  {
      "i": "6v8hmpdgpgx9",
      "h": "A",
      "s": "Lucas do Rio Verde, MT - BR-163 (BR-163) - Km 664",
      "r": 1000,
      "p": 4.9,
      "lat": -13.273693030151938,
      "lng": -56.02620167657733,
      "corrected": true
  },
  {
      "i": "6v8nnppzeh06",
      "h": "A",
      "s": "Lucas do Rio Verde, MT - MT-449 - Km 97",
      "r": 1000,
      "p": 5.1,
      "lat": -12.96841956002487,
      "lng": -55.9754110313952,
      "corrected": true
  },
  {
      "i": "6vb2gp4nenbj",
      "h": "A",
      "s": "Sorriso, MT - MT-242 - Km 66",
      "r": 1000,
      "p": 6.7,
      "lat": -12.484811602065022,
      "lng": -55.76373880729079,
      "corrected": true
  },
  {
      "i": "6vb2jzwu8j81",
      "h": "A",
      "s": "Sorriso, MT - MT-242 - Km 83",
      "r": 100,
      "p": 7.2,
      "lat": -12.614233332775354,
      "lng": -55.63647670671344,
      "corrected": true
  },
  {
      "i": "6vb3j4ygjsbn",
      "h": "A",
      "s": "Sorriso, MT - BR-163 (BR-163) - Km 766",
      "r": 500,
      "p": 7,
      "lat": -12.464833761620154,
      "lng": -55.66917719319463,
      "corrected": true
  },
  {
      "i": "7jgbxnekhh8q",
      "h": "A",
      "s": "Rafael Jambeiro, BA - BR 116 - Km 482",
      "r": 2500,
      "p": 4.5,
      "lat": -12.531863384368387,
      "lng": -39.41498586907983,
      "corrected": true
  },
  {
      "i": "7j6c2epm4zxf",
      "h": "A",
      "s": "Vitória da Conquista, BA - BR 116 - Km 873",
      "r": 300,
      "p": 4.5,
      "lat": -15.231766621557627,
      "lng": -41.100593972951174,
      "corrected": true
  },
  {
      "i": "7j7m0hp0ssbk",
      "h": "A",
      "s": "Planalto, BA - BR 116 - Km 773",
      "r": 600,
      "p": 4.5,
      "lat": -14.567746047812696,
      "lng": -40.4199049808085,
      "corrected": true
  },
  {
      "i": "7je2j1k2vfpb",
      "h": "A",
      "s": "Manuel Vitorino, BA - BR 116 - Km 698",
      "r": 1000,
      "p": 4.5,
      "lat": -14.056128850477014,
      "lng": -40.20423190668225,
      "corrected": true
  },
  {
      "i": "7jetfzb7xfrv",
      "h": "A",
      "s": "Brejões / Nova Itarana, BA - BR 116 - Km 566",
      "r": 500,
      "p": 4.5,
      "lat": -13.008817641268761,
      "lng": -39.957216549664736,
      "corrected": true
  },
  {
      "i": "7jswzj1gn5b5",
      "h": "A",
      "s": "Salvador, BA - BA-526 (BA-526) - Km 8",
      "r": 200,
      "p": 3.5,
      "lat": -12.848006435424672,
      "lng": -38.361586164683104,
      "corrected": true
  },
  {
      "i": "7jsxmqyyucxz",
      "h": "A",
      "s": "Simões Filho, BA - BR 324 - Km 597",
      "r": 500,
      "p": 2.5,
      "lat": -12.75119941650313,
      "lng": -38.43152778223157,
      "corrected": true
  },
  {
      "i": "7jsxv3xh62xz",
      "h": "A",
      "s": "Candeias, BA - BA-093 (BA-093) - Km 11",
      "r": 200,
      "p": 3.5,
      "lat": -12.691146182390488,
      "lng": -38.43139635398984,
      "corrected": true
  },
  {
      "i": "7jsxwk9evmxb",
      "h": "A",
      "s": "Simões Filho, BA - BA-093 (BA-093) - Km 8",
      "r": 200,
      "p": 3.5,
      "lat": -12.718421018919098,
      "lng": -38.39499341323972,
      "corrected": true
  },
  {
      "i": "7jsz19fhk0r9",
      "h": "A",
      "s": "Camaçari, BA - BA 099 - Km 14",
      "r": 100,
      "p": 5.4,
      "lat": -12.82168705947694,
      "lng": -38.251399006694555,
      "corrected": true
  },
  {
      "i": "7jsz21c0huzd",
      "h": "A",
      "s": "Camaçari, BA - BA-535 (BA-535) - Km 8",
      "r": 200,
      "p": 3.5,
      "lat": -12.778447000309823,
      "lng": -38.31873586401343,
      "corrected": true
  },
  {
      "i": "7ju3pjjnzfrw",
      "h": "A",
      "s": "Amélia Rodrigues, BA - BR 324 - Km 551",
      "r": 500,
      "p": 2.5,
      "lat": -12.451584858682125,
      "lng": -38.708444740623236,
      "corrected": true
  },
  {
      "i": "7juc204cmhzd",
      "h": "A",
      "s": "Mata de São João, BA - BA-093 (BA-093) - Km 44",
      "r": 200,
      "p": 3.5,
      "lat": -12.43678586080589,
      "lng": -38.315951731055975,
      "corrected": true
  },
  {
      "i": "7nx050c23uzs",
      "h": "A",
      "s": ", PE - (PE-009) - Km 49",
      "r": 200,
      "p": 6,
      "lat": -8.433674465428997,
      "lng": -35.02283474430442,
      "corrected": true
  },
  {
      "i": "7nx06g4sqch1",
      "h": "A",
      "s": ", PE - (VPE-052) - Km 0",
      "r": 200,
      "p": 6,
      "lat": -8.376382476130939,
      "lng": -35.031671952456236,
      "corrected": true
  },
  {
      "i": "7nx07mfc2yg9",
      "h": "A",
      "s": "Suape, PE - (PE-009) - Km 40",
      "r": 200,
      "p": 6,
      "lat": -8.3617949133279,
      "lng": -35.009691920131445,
      "corrected": true
  },
  {
      "i": "7nx0etd0j6rv",
      "h": "A",
      "s": "Cabo de Santo Agostinho, PE - (PE-009) - Km 35",
      "r": 200,
      "p": 6,
      "lat": -8.319336208994185,
      "lng": -34.99945627525449,
      "corrected": true
  },
  {
      "i": "7nx0gtdtxmbh",
      "h": "S",
      "s": ", PE - (PE-009) - Km 30",
      "r": 200,
      "p": 6,
      "lat": -8.274472936734934,
      "lng": -34.99870693311095,
      "corrected": true
  },
  {
      "i": "7nx0u98y3qzc",
      "h": "N",
      "s": "Cabo de Santo Agostinho, PE - - (nd) - Km 0",
      "r": 200,
      "p": 5,
      "lat": -8.29631862096385,
      "lng": -34.95729798451066,
      "corrected": true
  },
  {
      "i": "7nx1hgwmq3xf",
      "h": "S",
      "s": "Jaboatão dos Guararapes, PE - Km 0",
      "r": 100,
      "p": 5,
      "lat": -8.24160322845596,
      "lng": -34.93867674842477,
      "corrected": true
  },
  {
      "i": "6fekrps6fr85",
      "h": "A",
      "s": "Guaíba, RS - BR 116 - Km 303",
      "r": 100,
      "p": 0,
      "lat": -30.148861869355624,
      "lng": -51.36592084541917,
      "corrected": true
  },
  {
      "i": "6fem5b51jr23",
      "h": "A",
      "s": "Eldorado do Sul, RS - BR 290 - Km 129",
      "r": 100,
      "p": 0,
      "lat": -30.05838758812191,
      "lng": -51.51002520695329,
      "corrected": true
  },
  {
      "i": "6fet0hcyxu25",
      "h": "S",
      "s": "Eldorado do Sul, RS - BR 116 (BR 290) - Km 110",
      "r": 100,
      "p": 7.1,
      "lat": -30.031438666395072,
      "lng": -51.32522536441684,
      "corrected": true
  },
  {
      "i": "6fetwfb4tx01",
      "h": "A",
      "s": "Gravataí, RS - BR 290 - Km 77",
      "r": 100,
      "p": 3.5,
      "lat": -29.954904548409772,
      "lng": -51.0320277325809,
      "corrected": true
  },
  {
      "i": "6fgbbcsfdz2r",
      "h": "A",
      "s": "Gramado, RS - RS 235 - Km 28",
      "r": 100,
      "p": 5.9,
      "lat": -29.390598096248013,
      "lng": -50.9368565864861,
      "corrected": true
  },
  {
      "i": "6fgbhqqz6406",
      "h": "A",
      "s": "Três Coroas, RS - RS 115 - Km 23",
      "r": 3500,
      "p": 5.9,
      "lat": -29.495650650637163,
      "lng": -50.7804318331182,
      "corrected": true
  },
  {
      "i": "6fgcjtc3eukk",
      "h": "A",
      "s": "São Francisco de Paula, RS - RS 235 - Km 55",
      "r": 1100,
      "p": 5.9,
      "lat": -29.323564302605483,
      "lng": -50.73294533416629,
      "corrected": true
  },
  {
      "i": "6fsjup2jqj2j",
      "h": "L",
      "s": "Sto. Antônio da Patrulha, RS - BR 290 - Km 19",
      "r": 100,
      "p": 7.1,
      "lat": -29.88612822525769,
      "lng": -50.44885179027915,
      "corrected": true
  },
  {
      "i": "6fsnbervrq04",
      "h": "A",
      "s": "Santo Antônio da Patrulha, RS - RS 474 - Km 20",
      "r": 100,
      "p": 5.2,
      "lat": -29.732172774318908,
      "lng": -50.59203715994954,
      "corrected": true
  },
  {
      "i": "6g9c39x48h02",
      "h": "A",
      "s": "Céu Azul, PR - BR 277 - Km 620",
      "r": 100,
      "p": 11.3,
      "lat": -25.08415708829425,
      "lng": -53.71347030624747,
      "corrected": true
  },
  {
      "i": "6gd1esgws2xy",
      "h": "A",
      "s": "Cascavel, PR - BR 277 - Km 569",
      "r": 200,
      "p": 12.2,
      "lat": -25.02157774484489,
      "lng": -53.27874222770333,
      "corrected": true
  },
  {
      "i": "6gd55z6zm70n",
      "h": "A",
      "s": "Corbélia, PR - BR 369 - Km 493",
      "r": 100,
      "p": 12.3,
      "lat": -24.74400940197031,
      "lng": -53.26872585341334,
      "corrected": true
  },
  {
      "i": "6gdwm6cyt52h",
      "h": "A",
      "s": "Campo Mourão , PR - BR 369 - Km 377",
      "r": 100,
      "p": 12.3,
      "lat": -24.197639231359133,
      "lng": -52.501011583954096,
      "corrected": true
  },
  {
      "i": "6gfcw30ebfzf",
      "h": "A",
      "s": "Floresta , PR - PR-317 - Km 127",
      "r": 100,
      "p": 12.3,
      "lat": -23.63643097391547,
      "lng": -52.10755633190274,
      "corrected": true
  },
  {
      "i": "6gg4q8ut7m2j",
      "h": "A",
      "s": "Mandaguari, PR - BR 376 - Km 200",
      "r": 70,
      "p": 8.2,
      "lat": -23.505630515992387,
      "lng": -51.739404033869505,
      "corrected": true
  },
  {
      "i": "6gg7n7k2960j",
      "h": "A",
      "s": "Arapongas, PR - BR 369 - Km 178",
      "r": 50,
      "p": 8.2,
      "lat": -23.360930746326236,
      "lng": -51.39920672401786,
      "corrected": true
  },
  {
      "i": "6ggg86hj0h2p",
      "h": "A",
      "s": "Jataizinho, PR - BR 369 - Km 126",
      "r": 100,
      "p": 21,
      "lat": -23.279066242779052,
      "lng": -50.959918554872274,
      "corrected": true
  },
  {
      "i": "6ggvesk4f6b4",
      "h": "A",
      "s": "Sertaneja, PR - PR 323 - Km 3",
      "r": 100,
      "p": 18,
      "lat": -22.915603261643593,
      "lng": -50.817198883742094,
      "corrected": true
  },
  {
      "i": "6gup6bhbes05",
      "h": "A",
      "s": "Assis, SP - Rod. Raposo Tavares (SP 270) - Km 453",
      "r": 300,
      "p": 7.9,
      "lat": -22.632731015200992,
      "lng": -50.49661187455058,
      "corrected": true
  },
  {
      "i": "6guq6yzcrgrx",
      "h": "A",
      "s": "Palmital, SP - Rod. Raposo Tavares (SP 270) - Km 413",
      "r": 300,
      "p": 7.6,
      "lat": -22.769649670614985,
      "lng": -50.14518415555358,
      "corrected": true
  },
  {
      "i": "6u558nusp800",
      "h": "A",
      "s": "Caiuá, SP - Rod. Raposo Tavares (SP 270) - Km 639",
      "r": 400,
      "p": 6.4,
      "lat": -21.846912591898345,
      "lng": -52.024687808007,
      "corrected": true
  },
  {
      "i": "6u569yummj81",
      "h": "A",
      "s": "Presidente Bernardes, SP - Rod. Raposo Tavares (SP 270) - Km 590",
      "r": 100,
      "p": 8.5,
      "lat": -22.021860708488305,
      "lng": -51.597700249403715,
      "corrected": true
  },
  {
      "i": "6u58r7dny4bq",
      "h": "A",
      "s": "Rancharia, SP - Rod. Raposo Tavares (SP 270) - Km 512",
      "r": 300,
      "p": 6.4,
      "lat": -22.435341679000743,
      "lng": -51.008136961609125,
      "corrected": true
  },
  {
      "i": "6u591g3h7zzu",
      "h": "A",
      "s": "Regente Feijó, SP - Rod. Raposo Tavares (SP 270) - Km 541",
      "r": 300,
      "p": 6.5,
      "lat": -22.303904161207893,
      "lng": -51.25330226495862,
      "corrected": true
  },
  {
      "i": "6u5xzb6usuxf",
      "h": "A",
      "s": "Lavínia, SP - Rod. Mal. Rondon (SP 300) - Km 590",
      "r": 300,
      "p": 4.5,
      "lat": -21.136065369203987,
      "lng": -50.98387973383069,
      "corrected": true
  },
  {
      "i": "6u5zm74d4urx",
      "h": "A",
      "s": "Rubiácea, SP - Rod. Mal. Rondon (SP 300) - Km 560",
      "r": 100,
      "p": 5.6,
      "lat": -21.20906663678572,
      "lng": -50.742328371852636,
      "corrected": true
  },
  {
      "i": "6u737zzfsbzc",
      "h": "A",
      "s": "Castilho, SP - Rod. Mal. Rondon (SP 300) - Km 655",
      "r": 100,
      "p": 3.2,
      "lat": -20.830910191844342,
      "lng": -51.503973472863436,
      "corrected": true
  },
  {
      "i": "6u78d7egpyru",
      "h": "A",
      "s": "Guaraçaí, SP - Rod. Mal. Rondon (SP 300) - Km 621",
      "r": 400,
      "p": 4.3,
      "lat": -20.985032228649942,
      "lng": -51.22336344793439,
      "corrected": true
  },
  {
      "i": "6uhq1v57rfru",
      "h": "A",
      "s": "Glicério, SP - Rod. Mal. Rondon (SP 300) - Km 497",
      "r": 200,
      "p": 6.6,
      "lat": -21.417435763243294,
      "lng": -50.191847551614046,
      "corrected": true
  },
  {
      "i": "6uhscxf6kdbn",
      "h": "A",
      "s": "Promissão, SP - Rod. Mal. Rondon (SP 300) - Km 455",
      "r": 100,
      "p": 5.9,
      "lat": -21.622109843653412,
      "lng": -49.85280258581042,
      "corrected": true
  },
  {
      "i": "6uhsd8q94grt",
      "h": "A",
      "s": "Lins, SP - Rod. Transbrasiliana (BR 153) - Km 183",
      "r": 100,
      "p": 4.8,
      "lat": -21.711141573082273,
      "lng": -49.808403979986906,
      "corrected": true
  },
  {
      "i": "6uxyrs81nxzu",
      "h": "A",
      "s": "Felixlândia, MG - BR-040 (BR-040) - Km 328",
      "r": 1000,
      "p": 5.3,
      "lat": -18.565318744907103,
      "lng": -45.021082665771246,
      "corrected": true
  },
  {
      "i": "6uyukc8vdh06",
      "h": "A",
      "s": "Lagoa Grande, MG - BR-040 (BR-040) - Km 91",
      "r": 1000,
      "p": 5.3,
      "lat": -17.52497009049107,
      "lng": -46.54795730486512,
      "corrected": true
  },
  {
      "i": "6uywdg8k76pg",
      "h": "A",
      "s": "Paracatu, MG - BR-040 (BR-040) - Km 18",
      "r": 1000,
      "p": 5.3,
      "lat": -17.11869883633461,
      "lng": -46.98802599683404,
      "corrected": true
  },
  {
      "i": "6uz3bmp9gzpb",
      "h": "A",
      "s": "João Pinheiro, MG - BR-040 (BR-040) - Km 172",
      "r": 1000,
      "p": 5.3,
      "lat": -17.945693709092957,
      "lng": -46.034616362303495,
      "corrected": true
  },
  {
      "i": "6uz8yjw24h0p",
      "h": "A",
      "s": "São Gonçalo do Abaeté, MG - BR-040 (BR-040) - Km 254",
      "r": 1000,
      "p": 5.3,
      "lat": -18.1325697139029,
      "lng": -45.408015456050634,
      "corrected": true
  },
  {
      "i": "6vhbp30txsb3",
      "h": "A",
      "s": "Piracanjuba/Prof. Jamil, GO - BR-153 (BR-153) - Km 553",
      "r": 1000,
      "p": 5.2,
      "lat": -16.868533115718776,
      "lng": -49.25068387761712,
      "corrected": true
  },
  {
      "i": "6vj4s81wjcpg",
      "h": "A",
      "s": "Goianópolis, GO - BR-060 (BR-060) - Km 107",
      "r": 1000,
      "p": 3.6,
      "lat": -16.438089442577958,
      "lng": -49.01910262182355,
      "corrected": true
  },
  {
      "i": "6vjkq7nqux81",
      "h": "A",
      "s": "Alexânia, GO - BR-060 (BR-060) - Km 43",
      "r": 200,
      "p": 4.9,
      "lat": -16.109975270353527,
      "lng": -48.58387095853686,
      "corrected": true
  }
];



// WEBPACK FOOTER //
// ./src/pages/account/routing/rounting.js